// https://scotch.io/tutorials/simple-language-translation-in-angular-2-part-2

// lang-en.ts

// 'hello world': 'hello world',
// 'hello greet': 'Hello, %0 %1!',
// 'well done': 'Well done %0',
// 'good bye': 'bye bye',

export const LANG_PL_NAME = "pl";

export const LANG_PL_TRANS = {
  LblWeekdays: {
    shorthand: ["Nd", "Pn", "Wt", "Śr", "Cz", "Pt", "So"],
    longhand: [
      "Niedziela",
      "poniedziałek",
      "wtorek",
      "środa",
      "czwartek",
      "piątek",
      "sobota"
    ]
  },
  LblMonths: {
    shorthand: [
      "Sty",
      "Lut",
      "Mar",
      "Kwi",
      "Maj",
      "Cze",
      "Lip",
      "Sie",
      "Wrz",
      "Paź",
      "Lis",
      "Gru"
    ],
    longhand: [
      "Styczeń",
      "Luty",
      "Marzec",
      "Kwiecień",
      "Maj",
      "Czerwiec",
      "Lipiec",
      "Sierpień",
      "Wrzesień",
      "Październik",
      "Listopad",
      "Grudzień"
    ]
  },
  LblButtonText: {
    today: "Dzisiaj",
    month: "Miesiąc",
    week: "Tydzień",
    day: "Dzień",
    list: "Lista"
  },

  // Common Name
  LblActivityLog: "Dziennik aktywności",
  LblEdit: "Edytuj",
  LblDelete: "Usuń",
  LblRemove: "Usuń",
  LblActiveInactive: "Aktywny/nieaktywny",
  LblActive: "Aktywny",
  LblInactive: "Dezaktywuj",
  LblInactiveReason: "Nieaktywny Powód",
  LblAddNew: "Dodaj nowy",
  LblAdd: "Dodaj",
  LblUpdate: "Aktualizuj",
  LblSave: "Zapisz",
  LblCancel: "Anuluj",
  LblReset: "Resetuj",
  LblSelect: "Wybierz",
  LblSuccess: "Sukces",
  LblWarning: "Ostrzeżenie",
  LblList: "Lista",
  LblAssign: "Przypisz",
  LblHome: "Strona główna",
  LblYes: "Tak",
  LblOK: "Ok",
  LblNo: "Nie",
  LblBack: "Powrót",
  LblReason: "Powód",
  LblRecordSavedSuccess: "Rejestr zapisany pomyślnie",
  LblRecordDeleteSuccess: "Rejestr usunięty pomyślnie",
  LblResetPasswordSuccess: "Hasło zresetowane pomyślnie",
  LblConfirm: "Potwierdź",
  LblBlockUnblockConfirm: "Czy na pewno chcesz %0 %1 ?",
  LblRecordDeleteConfirmation: "Czy na pewno chcesz usunąć %0 ?",
  LblRecordMultiplDeleteConfirmation:
    "Czy na pewno chcesz usunąć wybrane %0 ?",
  LblConfirmMessage: "Czy jesteś pewien?",
  LblResetPassword: "Zresetuj hasło",
  LblResetPasswordConfirmation: "Czy na pewno chcesz zresetować hasło?",
  LblGeoLocationError: "Wprowadź poprawną lokalizację geograficzną",
  LblPersonDeleteCheck: "Usuń na stałe",
  LblBookingCancelSuccess: "Rezerwacje anulowane pomyślnie",
  LblBookingAbortSuccess: "Rezerwacja przerwana pomyślnie",
  LblBookingRevokeSuccess: "Rezerwacja unieważniona pomyślnie",
  LblContactPersonRemoveSuccess: "Osoba kontaktowa została usunięta",
  LblContactPersonAddedSuccess: "Dodano osobę kontaktową",
  LblNoRecords: "Brak dostępnego zapisu",
  LblAffectedBookingList: "Wadliwa lista rezerwacji",
  LblSubscriptionEndDateError: "Wpisz datę zakończenia subskrypcji",
  LblIsSpecialPeriodAllow:
    "WCzy chcesz zastosować specjalny okres rozliczeniowy? Jeśli jest on dostępny",
  LblContractSlotisnotdefined:
    "Typ umowy dla podanego poniżej przedziału czasowego nie jest zdefiniowany.",
  LblUnscubscribeSuccess: "Anulowanie subskrypcji zakończone sukcesem",
  LblModifiedBy: "Zmodyfikowano przez",
  LblModifiedDate: "Zmienione dane",
  LblContractTypeGroupAvailableForSubscription:
    "Brak dostępnej grupy typów umów, aby dodać nowy %0.",
  LblRemoveContactPersonConfirm:
    "Czy na pewno chcesz usunąć osobę wyznaczoną do kontaktu?",
  LblBookingApproveRejectSuccess: "%0 %1 pomyślnie",
  LblRecordAddedSuccess: "%0 dodano pomyślnie.",
  LblRecordUpdatedSuccess: "%0 zaktualizowano pomyślnie.",
  LblRecordRemovedSuccess: "%0 usunięto pomyślnie",
  LblRecordActiveInActiveSuccess: "%0 %1 pomyślnie.",
  LblinvoiceResendSuccess: "%0 wysłano ponownie",
  LblRecordBlokUnBlockSuccess: "%0 %1 pomyślnie.",
  LblEditPage: "Edytuj %0",
  LblAddPage: "Dodaj %0",
  LblListPage: "%0 Lista",
  LblKilometers: "Kilometr",
  LblKM: "Km",
  LblDeletePersonNote: "Faktury oczekujące na realizację dla tej osoby nie będą wysyłane",
  LblFileNotFound: "Plik nie istnieje, skontaktuj się z działem pomocy technicznej",


  //'LblRecordUnBlockedSuccess':'%0 unBlocked successfully',

  //Instance Clone

  'LblInstanceClone': 'Sklonuj platformę',
  'LblNewInstanceName': 'Nazwa nowej platformy',
  'LblCloneResult': 'Wynik klonowania',
  'LblCloneStatus': 'Status klonowania',
  'CloneError': 'Wystąpił błąd podczas klonowania przypadku i odpowiadających mu jednostek.',


  //Instance Page
  LblCarwiseEnable: "Odblokowano Carwise",
  LblAdminDependencyValidationOnDelete:
    "Wybrany Administrator nie może zostać usunięty, ponieważ jest powiązany z innym podmiotem.",
  LblAdminDependencyValidation:
    "Funkcja administratora nie może zostać usunięta, ponieważ jest powiązana z innym podmiotem.",
  LblAdminDependencyAlert: "Alert zależności od administratora",
  LblCarwiseConfiguration: "Konfiguracja Carwise",
  LblCarwiseConnectionUrl: "Url połączenia",
  LblCarwiseConnectionUsername: "Nazwa użytkownika połączenia",
  LblCarwiseConnectionPassword: "Hasło połączenia",
  LblCarwiseAutoDeleteFrequencyInDays: "Częstotliwość automatycznego usuwania (w dniach)",
  LblDamageImageExtentions: "Rozszerzenia zdjęć uszkodzeń",

  LblInstance: "Platforma",
  LblWegoAdminDependencyValidation:
    "Admin WeGo nie może zostać usunięty, ponieważ jest powiązany z innym podmiotem",
  LblInstanceName: "Nazwa platformy",
  LblInstanceType: "Typ platformy",
  LblDescription: "Opis",
  LblCurrencySymbol: "Symbol waluty",
  LblPreferredLanguage: "Język",
  LblTimeZone: "Strefa czasowa",
  LblCurrencyAbbreviation: "Skrót waluty",
  LblInstanceDeleteValidation:
    "Nie można usunąć platformy z powodu powiązania z innym podmiotem",
  LblIsBookingApprovalReq: "Wymagane zatwierdzenie rezerwacji",
  LblInstanceConfiguration: "Konfiguracja platformy",
  LblBookingAlertTime: "Czas powiadomienia o rezerwacji",
  LblBookingCancelTime: "Czas anulowania rezerwacji",
  LblBookingTemporaryTime: "Czas rezerwacji tymczasowej",
  LblVtsRequestTimeout: "Timeout wniosku VTS",
  LblVtsTripLogTimeout: "Timeout VTS danych podróży",
  LblEmailConfiguration: "Konfiguracja poczty elektronicznej (SMTP)",
  LblInSeconds: "W sekundach",
  LblFromEmail: "Z poczty elektronicznej",
  LblHost: "Host",
  LblPort: "Port",
  LblEnableSsl: "Włącz SSL",
  LblSmtpEmail: "Poczta elektroniczna SMTP",
  LblBookingCancelTimeMessage:
    "Określa czas (w sekundach), po którym anulowanie rezerwacji nie będzie możliwe",
  LblBookingTemporaryTimeMessage:
    "Czas dla rezerwacji tymczasowej. Gdy użytkownik wybrał pojazd do rezerwacji, ale nie został jeszcze zatwierdzony.",
  LblVtSRequestTimeoutMessage:
    "Dostępny czas dla polecenia Zablokuj/Odblokuj w aplikacji mobilnej.",
  LblVtsTriplogTimeoutMessage:
    "Czas dla obliczenia podróży po wybraniu polecenia Blokuj.",
  LblContractTypeDeleteValidation:
    "Nie można usunąć grupy typów umów ze względu na powiązanie z innym podmiotem",
  LblSelectFuelType: "Wybierz rodzaj paliwa",
  LblSelectPricingCatagory: "Wybierz kategorię cenową",
  LblSelectBodyStyle: "Wybierz styl nadwozia",
  LblSelectVehicleClass: "Wybierz klasę pojazdu",
  LblIsImportPersonAllow: "Pozwól zaimportować osobę",
  LblValidateLicenseA2SP: "Kontrola licencji A2SP",
  LblValidateLicense24IDCheck: "Kontrola licencji 24ID",
  LblValidateLicenseForAllBookings: "Potwierdzaj ponownie licencję przy każdej rezerwacji",

  LblGeofenceLocation: "Lokalizacja geofence",
  LblRadius: "Promień",
  LblEmailRecepients: "Odbiorcy e-maila",
  LblRecepients: "Odbiorcy",
  LblEmailAddresses: "Adresy e-mail",
  LblMap: "Mapa",

  // AFAS/Azure Config
  LblImportConfiguration: "Konfiguracja importu",
  LblImportConnectionType: "Typ połączenia",
  LblAfas: "AFAS",
  LblAzure: "Azure",
  LblAzureTenantId: "Identyfikator użytkownika Azure",
  LblAzureClientId: "Identyfikator klienta Azure",
  LblAzureClientSecret: "Klucz prywatny klienta Azure",
  LblAfasClientId: "ID klienta AFAS",
  LblAfasConnectorName: "Nazwa Connectora AFAS",
  LblAfasConnectionType: "Typ połączenia AFAS",
  LblAfasTest: "Test",
  LblAfasAccept: "Akceptacja",
  LblAfasProduction: "Produkcja",
  LblAfasToken: "Token AFAS",
  LblAfasClientIdError: "Proszę wprowadzić identyfikator klienta AFAS",
  LblAfasConnectorNameError: "Proszę wprowadzić identyfikator klienta AFAS",
  LblAfasConnectionTypeError: "Proszę wprowadzić typ połączenia AFAS",
  LblAfasTokenError: "Proszę wprowadzić Token AFAS",
  LblAzureTenantIdError: "Proszę wprowadzić identyfikator użytkownika Azure",
  LblAzureClientIdError: "Proszę wprowadzić identyfikator klienta Azure",
  LblAzureClientSecretError: "Proszę wprowadzić kod klienta Azure",

  // SSO Config
  LblSsoConfiguration: "Konfiguracja SSO",
  LblDefaultSsoSharedVehicleGroup: "Domyślna grupa pojazdów współdzielonych",
  LblDefaultSsoOrganization: "Domyślna organizacja",
  LblDefaultSsoSubscription: "Domyślna subskrypcja",

  // Dropoff Message
  LblDropoffMessageConfiguration: "Konfiguracja komunikatu Dropoff",
  LblDropoffMessageExternalUrl: "Adres zewnętrzny",
  LblDropoffMessageApiKey: "Klucz Api",
  LblDropoffMessageActive: "Aktywny",

  LblValidate: "Walidacja",
  LblRejection: "Odrzucenie",
  LblrejectionReasonMsg:
    "Proszę podać powód odrzucenia wybranych wniosków o rezerwację",
  LblApproveConfirmationMsg:
    "Czy na pewno chcesz zatwierdzić wszystkie wybrane wnioski o rezerwację?",

  LblBookingCalanderSettings: "Ustawienia kalendarza rezerwacji",
  LblShowDriverInfo: "Pokaż informacje o kierowcy w kalendarzu rezerwacji",
  LblOrganizationAdmin: "Administrator organizacji",
  LblDriverInfoToShow: "Informacje o kierowcy do pokazania",

  //Person Page
  LblUserName: "Nazwa użytkownika",
  LblFirstName: "Imię",
  LblLastName: "Nazwisko",
  LblEmail: "E-mail",
  LblMobileNumber: "Numer telefonu komórkowego",
  LblPhoneNumber: "Numer telefonu",
  LblHomeAddress: "Adres domowy",
  LblWorkAddress: "Adres miejsca pracy",
  LblHouseNo: "Nr domu",
  LblHouseExtention: "Nr mieszkania",
  LblStreetName: "Nazwa ulicy",
  LblCity: "Miasto",
  LblZipCode: "Kod pocztowy",
  LblPassword: "Hasło",
  LblConfirmPassword: "Potwierdź hasło",
  LblMiddleName: "Drugie imię",
  LblMandateId: "Identyfikator zezwolenia",
  LblMandateSignatureDate: "Data podpisania zezwolenia",
  LblIsAmmandment: "Poprawiono",
  LblRemovePersonDetails: "Usuń dane osoby",
  LblMonitoring: "Monitoring",
  LblDropoffMessage: "Komunikat Dropoff",
  LblPreferredlanguage: "Preferowany język",
  LblDebtornr: "Liczba należności",

  LblEnableLogin: "Włącz logowanie",
  LblEnableErrorEscalation: "Włącz eskalację błędów",
  LblErrorEscalationMinutes: "Minuty eskalacji błędów",

  //Booking Type
  LblNORMALBOOKINGTYPE: 'NORMALNY',
  LblMAINTENANCEBOOKINGTYPE: 'UTRZYMANIE',
  LblUNAVAILABLEBOOKINGTYPE: 'NIEDOSTĘPNY',

  //Booking Status
  LblABORTED: 'ODRZUCONY',
  LblCANCELLED: 'ANULOWANY',
  LblCONFIRMED: 'POTWIERDZONY',
  LblFINISHED: 'ZAKOŃCZONY',
  LblNOSHOW: 'NOSHOW',
  LblPENDING: 'W TRAKCIE REALIZACJI',
  LblREVOKED: 'ODWOŁANY',
  LblRUNNING: 'W TOKU',
  LblREADYFORPAYMENT: 'GOTOWY DO ZAPŁATY',

  //Invoice Status
  LblOPEN: 'OTWARTY',
  LblSENT: 'WYSŁANY',
  LblCLOSED: 'ZAMKNIĘTY',
  LblREQUESTFORPAYMENT: 'ŻĄDANIEZAPŁATY',
  LblREOPEN: 'PONOWNIEOTWARTY',

  //Booking Request Status
  LblAPPROVEDBOOKINGREQUEST: 'ZATWIERDZONY',
  LblREJECTEDBOOKINGREQUEST: 'ODRZUCONY',
  LblPENDINGBOOKINGREQUEST: 'W TRAKCIE REALIZACJI',


  // Error Log
  LblErrorLog: "Dziennik błędów",
  LblComponentName: "Nazwa składnika",
  LblLogType: "Typ dziennika",
  LblEventDateTime: "Data i czas zdarzenia",

  // Interface Status
  LblInterfaceStatus: "Status interfejsu",
  LblLastStatusChangeDateTime: "Ostatnia zmiana stanu DataGodzina",
  LblLastCarwisePollDateTime: "Ostatnia próba usunięcia usterki (Carwise Poll)",
  LblUpdatedDateTime: "Zaktualizowany czas",

  //ErrorEscalation
  LblDuplicateErrorEscalation:
    "Znaleziono podwójną konfigurację eskalacji błędu",
  LblErrorEscalation: "Eskalacja błędu",
  LblComponent: "Komponent",
  LblSelectAdminLevel: "Wybierz poziom administratora",
  LblWegoAdminLevel: "Poziom administratora Wego",
  LblCustomerAdminLevel: "Poziom administratora klienta",
  LblInstanceAdminLevel: "Poziom administratora platformy",
  //Company Page
  LblCompany: "Firma",
  LblCompanyName: "Nazwa firmy",
  LblContactPerson: "Osoba kontaktowa",
  LblCompanyAdmin: "Administrator firmy",
  LblCompanyAddress: "Adres firmy",
  LblInternalOrganization: "Organizacja wewnętrzna",
  LblNoOfVegicles: "Liczba pojazdów",
  LblNoOfSharedVehicleGroups: "Numer SVG",
  LblGeoLocation: "Geo Lokalizacja",
  LblSelectGeoLocation: "Wybierz lokalizację",
  LblPerson: "Osoba",
  LblRole: "Role",
  LblDateOfBirth: "Data urodzenia",
  LblDriverLicenceNumber: "Numer prawa jazdy",
  LblApkExiprationSetting: "Ustawienia powiadomień o okresowej konserwacji",
  LblApkTimeInterval: "Odstęp czasu między powiadomieniami",
  LblEmailNotification: "Powiadomienie e-mail",
  LblNotificationFrequency: "Częstotliwość powiadomień",
  lblThresholdFrequency: "Częstotliwość progowa",
  lblThresholdTimeInterval: "Odstęp czasowy progu",
  LblIsEmailEnabled: "E-mail powiadamiający",
  lblThreshold: "Okres progowy",
  LblFrequency: "Częstotliwość",
  LblDay: "Dzień",
  LblWeek: "TYDZIEŃ",
  LblMonth: "Miesiąc",
  lblPerBooking: "Perbooking",
  LblPersons: "Osoby",
  LblPersonOverview: "Przegląd osób",
  LblCompanies: "Firmy",
  //Vehicle Page
  LblVehicle: "Pojazd",
  LblVtsVehicle: "Pojazd VTS",
  LblFleetId: "ID floty",
  LblContractId: "Identyfikator umowy",
  LblVIN: "VIN",
  LblLicenceTag: "Znacznik licencji",
  LblLicence: "Licencja",
  LblMobile: "Mobilny",
  LblVehicleOwner: "Właściciel pojazdu",
  LblLocationDataExchange: "Wymiana danych dotyczących lokalizacji",
  LblBrand: "Marka",
  LblType: "Typ",
  LblColor: "Kolor",
  LblVehicleClass: "Klasa pojazdu",
  LblPricingCategory: "Kategoria cenowa",
  LblBodyStyle: "Styl nadwozia",
  LblAvailable: "Dostępny",
  LblUnAvailable: "Niedostępne",
  LblAvailableFrom: "Dostępny Od",
  LblAvailableTo: "Dostępny do",
  LblFuelType: "Typ paliwa",
  LblMinBookingTimeBefore: "Minimalny czas dostępny przed rezerwacją (minuty)",
  LblMinBookingTimeAfter: "Minimalny czas dostępny po rezerwacji (minuty)",
  LblTowbar: "Hak holowniczy",
  LblAirco: "Klimatyzacja",
  LblVehicleAttributes: "Atrybuty pojazdu",
  LblBlockUnBlock: "Zablokuj/Odblokuj",
  LblRemoveLicense: "Usuń prawo jazdy",
  LblRemoveLicenseBirthDate: "Usuń prawo jazdy i datę urodzenia",
  LblLicenseBirthDate: "Data urodzenia",
  LblBlock: "Zablokuj",
  LblUnblock: "Odblokuj",
  LblAvailableUnAvailable: "Dostępne/Niedostępne",
  LblVehicles: "Pojazdy",
  LblBookingsOverview: "Przegląd rezerwacji",
  LblApkExpirationDateCet: "Data wygaśnięcia okresowej konserwacji",
  LblEnabled: "Włączone",
  LblDisabled: "Wyłączone",
  LblIntialOdometerValue: "Początkowa wartość licznika kilometrów",
  LblFuelCardPinCode: "Kod PIN karty paliwowej",

  LblFuel: "Paliwo",
  LblVINnumber: "Numer VIN",
  LblVehicletype: "Typ pojazdu",
  LblDoors: "Liczba drzwi",
  LblWeight: "Masa pojazdu",
  LblTrunkSpace: "Przestrzeń bagażnika",
  LblGears: "Liczba biegów",
  LblEngineHorsepower: "Moc silnika (KM)",
  LblFuelConsumption: "Zużycie paliwa",
  LblSeats: "Liczba miejsc",
  LblDimensions: "Wymiary pojazdu",
  LblTransmissionType: "Typ skrzyni biegów",
  LblTransmissionUnknown: "Nieznany",
  LblManualTransmission: "Manualna",
  LblAutomaticTransmission: "Automatyczna",

  LblVehicleDetails: "Szczegóły pojazdu",
  LblSelectVehicletype: "Wybierz typ pojazdu",
  LblWrongVinNumber: "Nieprawidłowy numer VIN",


  //WEGO2DEV-325(Settings for Dashboard statuses)
  LblVehicleOnSameLocationTime: "Pojazd w tym samym miejscu przez więcej niż",
  LblNoBookingIn: "Pojazd nie zarezerwowany od ponad",
  lblHour: "Godzina",
  //'lblInterval':'HOUR/DAY/WEEK/MONTH',
  lblHourDayWeekMonth: "Godzina / Dzień / Tydzień / Miesiąc",

  //SharedVehicleGroup
  LblSharedVehicleGroup: "Wspólna grupa pojazdów",
  LblVehicleGroup: "Grupa pojazdów",
  LblSharedVehicleGroupAdmin: "Administrator współdzielonej grupy pojazdów",
  LblDisplayPeriod: "Wyświetl okres",
  LblBookingWeekDays: "Dni rezerwacji",
  LblBookingInterval: "Odstęp czasu między rezerwacjami (minuty)",
  LblBookingStartTime: "Godzina rozpoczęcia rezerwacji (gg:mm)",
  LblBookingEndTime: "Godzina zakończenia rezerwacji (gg:mm)",
  LblBookingMinDuration: "Minimalny czas trwania rezerwacji (minuty)",
  LblBookingMaxDuration: "Maksymalny czas trwania rezerwacji (minuty)",
  LblMaxRecurringBooking: "Maksymalna rezerwacja cykliczna",
  LblPreBookingInterval: "Odstęp czasu między rezerwacjami wstępnymi (minuty)",
  LblPostBookingInterval: "Odstęp czasu po dokonaniu rezerwacji (minuty)",
  LblBookingExtensionTime: "Maksymalny czas przedłużenia rezerwacji (minuty)",
  LblBookAheadTime: 'Rezerwacja możliwa X" minut od teraz',
  LblBookingHorizon: "Najpóźniejszy możliwy czas dokonania rezerwacji",
  LblNumberOfContactTypeGroup: "Liczba grup typów umów",
  LblNumberOfContactType: "Liczba typów umów",
  LblInvoiceInterval: "Przedział czasowy faktury",
  LblIsBookingIntervalAlignToCalendar: "Dopasuj przedział rezerwacji do kalendarza",
  LblBookings: "Rezerwacje",
  LblSharedVehicleGroups: "Grupy wspólnych pojazdów",
  LblSharedVehicleGroupOverview: "Przegląd wspólnych grup pojazdów",
  LblEarlyOpenInterval: "Przedział czasowy (minuty)",
  LblFeatureFlags: "Feature Flags",
  LblCreateBooking: "Utwórz rezerwację",
  LblEditBooking: "Edytuj rezerwację",
  LblLicenseCheck: "Sprawdzanie licencji",
  LblBookingLicenseCheck: "Sprawdzenie licencji rezerwacji",

  //Driver
  LblDriver: "Kierowca",
  LblLicenceNumber: "Nr licencji",
  LblDriverName: "Nazwisko kierowcy",
  LblDriverSVG: "Grupa pojazdów współdzielonych przez kierowcę",
  LblDriverUserName: "Nazwa użytkownika kierowcy",

  //VehicleAttribute
  LblVehicleAttributeCategory: "Kategoria atrybutu pojazdu",
  LblVehicleAttributeName: "Nazwa atrybutu",
  LblVehicleAttributeDesc: "Opis",
  LblVehicleAttribute: "Atrybut pojazdu",
  LbAdditionallVehicleAttribute: "Dodatkowe atrybuty pojazdu",
  LblVehicleAttributeCategories: "Kategorie atrybutów pojazdu",

  //ContractType Page
  LblRegular: "Regularnie",
  LblWeekEnd: "Weekend",
  LblDayCT: "Dzień",
  LblExtraTimeBefore: "Dodatkowy czas przed (minuty)",
  LblExtraTimeAfter: "Dodatkowy czas po (minuty)",
  LblFreeTextDescription: "Podaj stawkę za rezerwację specjalną oraz czas rozpoczęcia i zakończenia (dowolny tekst)",
  LblPeriodRate: "Stawka za okres",
  LblPeriodRateVat: "Kwota VAT stawki za okres",
  LblSelectContractTypeType: "Wybierz typ rodzaju umowy",
  LblContractTypeType: "Typ rodzaju umowy",
  LblContractType: "Typ umowy",
  LblContractName: "Nazwa umowy",
  LblContractTypeGroup: "Grupa typów umowy",
  LblContractTypeGroupName: "Nazwa grupy typów umowy",
  LblContractAvailableDays: "Dostępne dni dla umowy",
  LblApplicableDays: "Obowiązujące dni",
  LblDayStartTime: "Godzina rozpoczęcia dnia (gg:mm)",
  LblDayEndTime: "Godzina zakończenia dnia (gg:mm)",
  LblApplicableStartTime: "Obowiązująca godzina rozpoczęcia (gg:mm)",
  LblApplicableEndTime: "Obowiązująca godzina zakończenia (gg:mm)",
  LblComment: "Skomentuj",
  LblProcessingFee: "Opłata za przetwarzanie",
  LblVatPercentage: "Procent VAT",
  LblVatIncludedInPrice: "VAT zawarty w cenie",
  LblPlateformUsageCost: "Koszt użytkowania platformy",
  LblCatA: "Kategoria A",
  LblCatB: "Kategoria B",
  LblCatC: "Kategoria C",
  LblCatD: "Kategoria D",
  LblCatE: "Kategoria E",
  LblCatF: "Kategoria F",
  LblCatG: "Kategoria G",
  LblCatH: "Kategoria H",
  LblHourlyRate: "Koszt czasu",
  LblMileageRate: "Stawka za kilometr",
  LblFixedFee: "Opłata stała",
  LblPricingModel: "Model cenowy",
  LblContractStartDateTime: "Data/czas rozpoczęcia umowy",
  LblContractEndDateTime: "Data/czas zakończenia umowy",
  LblContractTypeHistory: "Historia",
  LblContractTypPeriod: "Okres obowiązywania typu umowy",
  LblInactiveContractTypeGroupReason:
    "Powód deaktywacji grupy typów umów",
  LblPenaltyAmount: "Kwota kary",
  LblPenaltyTimeInterval: "Przedział czasu kary (minuty)",
  LblIsPenaltyEnabled: "Kara włączona",
  LblTripDisplayType: "Jak powinny być prezentowane przejazdy w raportach?",
  LblAllTripsIndividually: "Wszystkie podróże indywidualnie",
  LblAllTripsGrouped: "Wszystkie podróże zgrupowane w jedną podróż",

  // DateTime Picker
  LblJanuary: "Styczeń",
  LblFebruary: "Luty",
  LblMarch: "Marzec",
  LblApril: "Kwiecień",
  LblMay: "Maj",
  LblJune: "Czerwiec",
  LblJuly: "Lipiec",
  LblAugust: "Sierpień",
  LblSeptember: "Wrzesień",
  LblOctober: "Październik",
  LblNovember: "Listopad",
  LblDecember: "Grudzień",

  LblSJan: "St",
  LblSFeb: "Lut",
  LblSMar: "Mrz",
  LblSApr: "Kw",
  LblSMay: "Maj",
  LblSJun: "Cz",
  LblSJul: "Lip",
  LblSAug: "Sier",
  LblSSep: "Wrz",
  LblSOct: "Paź",
  LblSNov: "Lis",
  LblSDec: "Gr",

  LblSunday: "Niedziela",
  LblMonday: "Poniedziałek",
  LblTuesday: "Wtorek",
  LblWednesday: "Środa",
  LblThursday: "Czwartek",
  LblFriday: "Piątek",
  LblSaturday: "Sobota",

  LblSSu: "Nd",
  LblSMo: "Pon",
  LblSTu: "Wt",
  LblSWe: "Śr",
  LblSTh: "Czw",
  LblSFr: "Pt",
  LblSSa: "Sob",

  //Forgot Password
  LblForgotPassword: "Nie pamiętam hasła",
  LblChangePassword: "Zmień hasło",
  LblOldPassword: "Stare hasło",
  LblNewPassword: "Hasło",
  LblProfileUpdatedSucessFully: "Profil został pomyślnie zaktualizowany",
  LblPasswordChangedSucessFully: "Hasło zmienione pomyślnie",

  //
  LblUpdateProfile: "Zaktualizuj profil",
  LbLReasonVehicle: "Powód niedostępności",
  LblReasonDriver: "Powód zablokowania kierowcy",

  //Booking
  LblFrom: "Od",
  LblApprovalAdminName: "Zatwierdzone przez administratora",
  LblApprovedRejectedby: "Zatwierdzone/Odrzucone przez",
  LblBookingRequestList: "Lista wniosków o rezerwację",
  LblTo: "Do",
  LblBooking: "Rezerwacja",
  LblBookingRequest: "Zapytanie o rezerwację",
  LblOverview: "Przegląd rezerwacji",
  LblOverviewList: "Lista przeglądów rezerwacji",
  LblApproveBooking: "Zatwierdzanie rezerwacji",
  LblApprove: "Zatwierdź",
  LblBookingApprovedSuccessMsg:
    "Wybrane żądania rezerwacji zatwierdzone pomyślnie",
  LblBookingRejectedSuccessMsg:
    "Wybrane zapytania o rezerwację odrzucone pomyślnie",
  LblReject: "Odrzuć",
  LblNormal: "Nowa rezerwacja",
  LblSpecial: "Rezerwacja specjalna",
  LblHistory: "Historia rezerwacji",
  LblBookingStatus: "Status rezerwacji",
  LblBookingType: "Typ rezerwacji",
  LblAdminRemarks: "Uwagi administratora",
  LblBookingRemarks: "Uwagi do rezerwacji",
  LblDriverRemarks: "Uwagi kierowcy",
  LblBookingReferenceId: "ID rezerwacji",
  SelectionRequiredMsg: "Proszę wybrać co najmniej jedną rezerwację do zatwierdzenia/odrzucenia",
  LblSelectionRequired: "Wymagany wybór",
  LblAbort: "Przerwij",
  LblRevoke: "Odwołaj",
  LblStatus: "Status",
  LblReference: "ReferenceID",
  LblRemarks: "Uwagi",
  LblSearchForVehicle: "Wyszukiwanie pojazdu",
  LblVehicleOverview: "Przegląd pojazdu",
  LblConfirmBooking: "Potwierdź rezerwację",
  LblCurrentBookingDetail: "Szczegóły obecnej rezerwacji",
  LblCheckAvailability: "Sprawdź dostępność",
  LblBookingStartDateTime: "Początek rezerwacji",
  LblBookingEndDateTime: "Koniec rezerwacji",
  LblSource: "Źródło",
  LblRecurring: "Cykliczne",
  LblRecurringId: "ID rezerwacji cyklicznej",
  LblRecurringBookingReference: "Odnośnik rezerwacji cyklicznej",
  LblDaily: "Codziennie",
  LblWeekly: "Co tydzień",
  LblMonthly: "Miesięcznie",
  LblRecurrenceEndDate: "Data zakończenia powtarzania",
  LblSearch: "Szukaj",
  LblBookNow: "Zarezerwuj teraz",
  LblUpdateBooking: "Aktualizuj rezerwację",
  LblEditCarNotAvailable: "Pierwotnie zarezerwowany samochód nie jest dostępny",
  LblSortBy: "Sortuj według",
  LblAvaibility: "Dostępność",
  LblDistance: "Odległość",
  LblNoMatchingVehicle: "Nie znaleziono pasujących pojazdów",
  LblAvailableSlots: "Dostępne sloty",
  LblFeatures: "Funkcje?",
  LblDriverDetail: "Szczegóły o kierowcy",
  LblBookingDetail: "Szczegóły rezerwacji",
  LblVehicleDetail: "Dane pojazdu",
  LblBookingSuccess:
    "Udało Ci się utworzyć wniosek o rezerwację. Kopia wniosku jest wysyłana na zarejestrowany adres e-mail. Wysyłane jest również powiadomienie do zatwierdzenia, a Ty zostaniesz powiadomiony, gdy rezerwacja zostanie zaakceptowana.",
  LblBookingUpdateSuccess:
    "Rezerwacja została pomyślnie zaktualizowana. Powiadomienie zostaje wysłane na adres e-mail kierowcy.",
  LblBlockNormalBooking:
    "Twoje konto jest zablokowane. Prosimy o kontakt z administratorem.",
  LblSingle: "Pojedynczy",
  LblSeries: "Seria",
  LblAll: "Wszystkie",
  LblLicenceRequired1: "Proszę sprawdzić numer licencji, przejdź do",
  LblLicenceRequired2: "aby zaktualizować szczegóły numeru licencji",
  LblAcceptOrReject: "Zatwierdź / Odrzuć",

  //Special Booking
  LblSpecialBooking: "Rezerwacja specjalna",
  LblAffectedBooking: "Rezerwacja naruszona",
  LblSpecialBookingType: "Typ rezerwacji specjalnej",
  LblSelectSpecialBookingType: "Wybierz typ rezerwacji specjalnej",
  LblSpecialBookingConfiramtionmsg: "Czy na pewno chcesz utworzyć rezerwację specjalną?",
  LblEndDate: "Data zakończenia powtarzalności",

  // Notification
  LblNotification: "Powiadomienie",
  LblSubject: "Przedmiot",
  LblDate: "Data",
  LblWelcomeNotification: "Witamy w skrzynce powiadomień WeGo",

  //Template
  LblTemplate: "Szablon",
  LblTemplateList: "Lista szablonów",
  LblTemplateName: "Nazwa szablonu",
  LblTemplateType: "Typ szablonu",
  LblBody: "Nadwozie",
  LblIsEmailTemplate: "Email",
  LblIsWebTemplate: "Strona internetowa",

  // Notification Event Management
  LblNotificationEventManagement: "Zarządzanie zdarzeniami powiadamiania",
  LblNotificationEvent: "Zdarzenie powiadamiania",
  LblModuleName: "Nazwa modułu",
  LblSMS: "SMS",
  //User Type
  LblUserType: "Typ użytkownika",

  //TimeBlock

  LblTimeBlock: "Blok czasowy",
  LblTimeBlockName: "Nazwa bloku czasowego",
  LblTimeBlockWeekDays: "Blok czasowy Dni tygodnia",
  LblTimeBlockStartTime: "Czas rozpoczęcia bloku czasowego",
  LblTimeBlockEndTime: "Czas zakończenia bloku czasowego",
  LblTimeBlockStartDate: "Data rozpoczęcia bloku czasowego",
  LblTimeBlockEndDate: "Data zakończenia bloku czasowego",

  // Service Offer
  LblServiceOffer: "Oferta serwisowa",
  LblServiceOfferList: "Lista ofert serwisowych",
  LblServiceOfferName: "Nazwa oferty",
  LblServiceOfferType: "Typ oferty",

  LblStandardTariff: "Taryfa standardowa",
  LblTimeUsedOrBooked: "Czas wykorzystany/ zarezerwowany",
  LblPenalty: "Kara umowna",
  LblAdditional: "Dodatkowa",
  LblAdditionalAbbr: "Dodatkowa",
  LblUnit: "Jednostka",

  //WegoAdminList
  LblWegoAdmin: "Administrator WeGo",
  LblWegoAdmins: "Administratorzy WeGo",

  LblReSend: "Wyślij ponownie",
  LblResendActivationMail: "E-mail aktywacyjny",
  LblResendActivationMailFailure: "Nie udało się wysłać e-maila aktywacyjnego",
  LblResendActivationMailSuccess: "E-mail aktywacyjny został wysłany",

  //Subscription
  LblSubscription: "Subskrypcja",
  LblSubscriptionName: "Nazwa subskrypcji",
  LblTimeInterval: "Odstęp czasu",
  LblAmount: "Kwota",
  LblFreeKilometer: "Bezpłatne kredyty",
  LblFreeMinute: "Bezpłatne minuty",
  LblFreeHours: "Bezpłatne godziny",
  LblNumberOfSubscription: "Liczba subskrypcji",
  LblUnsubscribe: "Odsubskrybuj",
  LblsubscribeEndDate: "Data zakończenia subskrypcji",
  LblSubscriptionStartDate: "Data rozpoczęcia subskrypcji",
  //Special Period
  LblSpecialPeriod: "Okres Specjalny",
  LblspecialPeriodName: "Nazwa Okresu Specjalnego",
  LblSpecialPeriodStartTime: "Godzina rozpoczęcia Okresu Specjalnego",
  LblSpecialPeriodEndTime: "Godzina zakończenia okresu specjalnego",
  LblSpecialPeriodWeekDays: "Okres specjalny Dni tygodnia",
  LblNormalPeriod: "Okres zwykły",
  LblSpecialPeriods: "Okresy specjalne",
  //Booking InvoiceModel
  LblBookingInvoice: "Faktura Rezerwacji",
  LblInvoiceStatus: "Status faktury",
  LblInvoiceType: "Typ faktury",
  LblSummary: "Podsumowanie",
  LblTotalHours: "Całkowita liczba godzin",
  LblTotalKm: "Całkowita odległość (km.)",
  LblTotalExpense: "Wydatki ogółem",
  LblInvoiceNumber: "Numer faktury",
  LblBegin: "Początek",
  LblEnd: "Koniec",
  LblVat: "VAT",
  LblDone: "Gotowe",
  LblClear: "Wyczyść",
  LblTotal: "Razem",
  LblInvoiceRequestDateTime: "Data zażądania faktury",
  LblInvoiceSendDateTime: "Data wysłania faktury",
  LblInvoiceDateTime: "Data faktury",
  LblInvoiceDetail: "Szczegóły faktury",
  LblResend: "Wyślij ponownie",
  LblDownload: "Pobierz",
  LblResendInvoiceConfirm: "Czy na pewno chcesz wysłać ponownie %0?",
  LblSendInvoiceConfirm: "Czy na pewno chcesz wysłać fakturę?",
  LblPenaltyRate: "Stawka kary",
  LblInvoicing: "Fakturowanie",
  LblInvoices: "Faktury",

  LblProfile: "Profil",
  LblSignOut: "Wyloguj się",
  LblTemplateNote1:
    "Proszę nie zmieniać/usuwać tekstu napisanego w ten sposób { variablename }. Jest to dynamiczna nazwa atrybutu, która zostanie zastąpiona przez rzeczywisty wpis w bazie danych, gdy email zostanie wysłany do użytkownika.",
  LblTemplateNote2:
    "Proszę nie modyfikować struktury tabeli. Możesz stworzyć nową, a stara nie powinna być modyfikowana.",
  LblTemplateNote3:
    'Upewnij się, że po skopiowaniu symoblu zastępczego i wklejeniu go do edytora html, musisz użyć funkcji Kopiuj w postaci zwykłego tekstu "plain text".',
  LblConfirmUnsubscribe: "Czy na pewno chcesz zakończyć subskrypcję?",
  LblDriveHours: "Godziny jazdy",
  LblVehicleImage: "Obraz pojazdu",
  LblMaintenance: "Serwis",
  LblUNAVAILABLE: "Niedostępne",
  LblTestInvoiceGenerator: "Generator faktur testowych",
  LblMissingInvoiceGenerator: "Brak generatora faktur",
  LblInvoicingDateTime: "Data wystawienia faktury (UTC)",
  LblGenerateInvoice: "Wygeneruj fakturę",
  LblDeleteAllSelectedRecords: "Usuń wszystkie wybrane zapisy",
  LblCancelAllSelectedRecords: "Anuluj wszystkie wybrane zapisy",
  "LblExportAll(CSV)": "Eksportuj wszystko (CSV)",
  LblAddContactPerson: "Dodaj osobę kontaktową",
  LblRemoveContactPerson: "Usuń osobę kontaktową",
  LblNote: "Notatka",
  LblCompletelyEndConfirm: "Całkowicie zakończ podróż",
  LblEndTrip: "Zakończ podróż",
  LblTestTrip: "Testuj podróż",
  LblTripSimulator: "Symulator podróży",
  LblPrePostTripQuestions: "Pytania przed i po wycieczce",
  LblTestTripSuccess: "Wycieczka testowa utworzona z powodzeniem",
  LblDrivingStartDateTime: "Data / godzina rozpoczęcia jazdy",
  LblDrivingEndDateTime: "Data / godzina zakończenia jazdy",
  LblInvoiceMoment: "Moment wystawienia faktury",
  LblExtend: "Rozszerzenie pliku",
  LblExtendRequire: "Proszę wprowadzić czas przedłużenia rezerwacji (w minutach)",
  LblExtendInfoMsg: "Możesz przedłużyć rezerwację do %0 min",
  LblExtendValidationMsg: "Ta rezerwacja nie może być przedłużona",
  LblExtendBooking: "Przedłużenie rezerwacji",
  LblBookingExtendedSuccess: "Rezerwacja została przedłużona pomyślnie",
  LblOverExtendValidationMsg: "Nie można przedłużyć rezerwacji o więcej niż %0 minut",
  LblUnLock: "Odblokuj",
  LblLock: "Zablokuj",
  LblVehicleStatus: "Status pojazdu",
  LblTripSuccess: "Podróż zapisana pomyślnie",

  LblLockSuccessfully: "Pojazd zablokowany pomyślnie",
  LblLockCompletelySuccessfully: "Pojazd zablokowany pomyślnie",
  LblUnLockSuccessfully: "Pojazd odblokowany pomyślnie",
  LblUnlockProblem: "Problem podczas polecenia odblokowania",
  LbllockProblem: "Problem podczas polecenia zablokowania",
  LblLockCarCompletely: "Zablokuj i zamknij rezerwację",
  LblStartDateTime: "Data/godzina rozpoczęcia",
  LblEndDateTime: "Data/godzina zakończenia rezerwacji",
  LblBookingTripDetail: "Szczegóły rezerwacji podróży",
  LblAddNewTrip: "Dodaj nową podróż",
  LblBookingExpenseDetail: "Szczegóły wydatków dot. rezerwacji",
  LblUnlockErrorMessage:
    "Brak aktywnej grupy typu umowy dostępnej w czasie tworzenia rezerwacji",
  LblExpenseAmount: "Kwota wydatku",
  LblExpenseName: "Nazwa wydatku",
  LblExpenseSuccess: "Wydatek zapisany pomyślnie",
  LblReceipt: "Pokwitowanie",
  LblHelpdeskNo: "Nr pomocy technicznej",
  LblBookingExpired: "Pojazd nie może być odblokowany, ponieważ rezerwacja wygasła",
  LblTripCalculationInProgress:
    "Mamy nadzieję, że miałeś miłą podróż! Pojazd zostanie zamknięty za kilka sekund.",

  LblVTSReqLogDetail: "Szczegóły dziennika zgłoszeń VTS",
  LblVTSReqDateTime: "Data/godzina zgłoszenia",
  LblVTSProcessTime: "Czas przetwarzania",
  LblVTSResTime: "Czas wyniku",
  LblVTSReqType: "Typ żądania",
  LblVTSResult: "Wynik",
  LblActualInvoiceGenerationDate: "Data wygenerowania faktury",
  LblAvailableForAllSlots: "Pojazd dostępny dla wszystkich slotów",
  LblUnAvailableSlots: "Niedostępne sloty",
  LblNoOfDrivers: "Liczba kierowców",
  LblSVGDriversList: "Kierowcy z grupy pojazdów współdzielonych",
  LblVehicleInformation: "Informacje o pojeździe",
  LblVTSVehicle: "Pojazd VTS",
  LblVTSVehicleUpdateSuccess: "Pojazd %0 pomyślnie.",
  LblVTSVehicleList: "Lista pojazdów VTS",
  //Report Damage
  LblReportDamage: "Zgłoś szkodę",
  LblCompleteDamageReport: "Uzupełnij zgłoszenie szkody",
  LblDamageFile: "Plik uszkodzeń",
  LblDescribe: "Opisz szkodę...",
  LblCause: "Opisz przyczynę...",
  LblReportDamageMsg: "Szkoda została zgłoszona pomyślnie",
  LblSelectFile: "Proszę wybrać plik",

  // Import Data
  LblCSVImport: "Importuj CSV",
  LblValidateCSV: "Sprawdź CSV",
  LblImportValidPerson: "Importuj prawidłową osobę",
  LblImportValidDriver: "Importuj poprawnego kierowcę",
  LblImportValidVehicle: "Importuj ważny pojazd",
  LblCSVType: "Typ CSV",
  LblCSVFile: "Plik CSV",
  LblRecordImportedSuccess: "%0 zostało zaimportowane z powodzeniem",
  LblInvalidReason: "Nieważny powód",
  LblSameVTSCommand: "Żądanie jest już w toku. Proszę czekać.",
  LblImportPerson: "Importuj osobę",

  //Subscription related Changes
  LblSubscriptionInterval: "Okres subskrypcji",
  LblPaymentInterval: "Okres płatności",
  LblInvoicInterval: "Okres faktury",
  LblInterval: "Okres/Przedział",
  LblInvoiceMomentDay: "Moment wystawienia faktury (dzień tygodnia)",
  LblInvoiceMomentMonth: "Moment wystawienia faktury (dzień miesiąca)",
  LblFreeMinuteInterval: "Przedział darmowych minut",
  LblFreeKMInterval: "Przedział bezpłatnych kilometrów",
  LblSelectSubscriptionInterval: "Wybierz przedział abonamentu",
  LblSelectInvoiceInterval: "Wybierz przedział czasowy faktury",
  LblSelectPaymentInterval: "Wybierz przedział płatności",
  LblSelectFreeKMInterval: "Wybierz przedział bezpłatnych Kilometrów",
  LblSelectFreeMinInterval: "Wybierz przedział minutowy",
  LblYearlySub: "Roczny",
  LblMonthlySub: "Miesięczny",
  LblWeeklySub: "Tygodniowy",
  LblFreePerWeek: "Na tydzień",
  LblFreePerMonth: "Za miesiąc",
  LblFreePerTriMonth: "Za 3 miesiące",
  LblFreePerBiannual: "Za 6 miesięcy",
  LblFreePerYear: "Za rok",
  LblDefaultContractTypeGroup: "Domyślna grupa typów umów",
  LblSelectDefaultContractTypeGroup: "Wybierz domyślną grupę typów umów",
  LblSendInvoiceToDriver: "Wyślij fakturę do kierowcy",
  LblInherit: "Przejęcie",

  //Invoice Moment
  LblDayOfMonth: "Dzień miesiąca",
  LblDayOfWeek: "Dzień tygodnia",
  LblSelectDayOfWeek: "Wybierz dzień tygodnia",
  LblInstanceLogo: "Logo platformy",
  LblInvoiceDeleteValidation:
    "Nie można usunąć faktury z powodu powiązania z innym podmiotem",

  //SubscriptionAvailabilityRestriction
  LblSubscriptionAvailabilityRestriction:
    "Ograniczenie dostępności subskrypcji",
  LblStartDay: "Dzień rozpoczęcia",
  LblEndDay: "Dzień zakończenia",
  LblStartTime: "Godzina rozpoczęcia (hh:mm)",
  LblEndTime: "Czas zakończenia (hh:mm)",
  LblRestriction: "Ograniczenie",
  LblTotalFreeKilometer: "Liczba darmowych kilometrów",
  LblTotalFreeMinute: "Liczba darmowych minut",
  LblCurRemainFreeKilometer: "Pozostałe darmowe kilometry",
  LblPrevRemainFreeKilometer: "Poprzednie pozostałe darmowe kilometry",
  LblCurRemainFreeMinute: "Pozostałe darmowe minuty",
  LblPrevRemainFreeMinute: "Poprzednie pozostałe darmowe minuty",
  LblResetPasswordFailure:
    "Hasło nie może zostać zresetowane, ponieważ użytkownik nie jest jeszcze aktywowany.",

  //Additional Free Item
  LblAdditionalFreeItems: "Dodatkowe darmowe kredyty",
  LblDateAwared: "Data przyznania",
  LblAdditionalFreeItemsMenu: "Dodatkowe darmowe kredyty",

  LblPrevious: "Poprzedni",
  LblCurrent: "Bieżący",

  LblTripDetailReport: "Raport szczegółowy z podróży",
  LblTripDetailList: "Szczegółowy przegląd rezerwacji",
  LblSearchTripforDriver: "Wyszukaj rezerwację podróży kierowcy",
  LblExportReport: "Eksportuj raport",
  LblValidateLiceanceNumberMessage: "Proszę potwierdzić swój numer licencji",
  LblBookingIntervalRate: "Stawka za interwał",
  LblPerHour: "Za godzinę",
  LblPerBookingIntarval: "Za interwał rezerwacji",
  LblTimeRate: "Czas trwania rezerwacji",
  LblToalBookingDuration: "Czas trwania rezerwacji",

  LblTripComments: "Komentarz do podróży",
  LblTripCommentDescription: "Wpisz komentarz do podróży",
  LblTripCommentError: "Proszę wpisać komentarz do podróży",
  LblShowTripComment: "Zobacz komentarz",
  LblAddTripComment: "Dodaj komentarz",
  LblTripCommentBy: "Komentarz do pordóży napisany przez",
  LblTripCommentOn: "Komentarz do wycieczki op",  

  LblCleanRequire: "Wymagane czyszczenie",
  LblFualRequire: "Wymagane paliwo",
  LblVehicleDamageList: "Lista uszkodzeń pojazdu",
  LblDamageCause: "Uszkodzenie Przyczyna",
  LblDamageReportedBy: "Zgłoszone przez",
  LblDamageReportedOn: "Zgłoszona w dniu",
  LblConfirmResolveDamage: "Czy na pewno chcesz zlikwidować szkodę w pojeździe?",
  LblVehicleDamgeResolveSuccess: "Uszkodzenie pojazdu zostało pomyślnie rozwiązane",
  LblDamageDesc: "Opis szkody",
  LblFutureBooking: "Przyszłe rezerwacje",
  LblVehFutureBookingList: "Lista przyszłych rezerwacji pojazdu",
  LblResolveDamge: "Usunięcie szkody",
  LblReserved: "Zarezerwowane",
  LblVehicleInfoSuccess: "Udana aktualizacja informacji o pojeździe",
  LblInformation: "Informacje",
  LblVTSHistory: "Historia zdarzeń VTS",
  LblWegoRequestTime: "Czas żądania WeGo",
  LblVTSRequestTime: "Czas żądania VTS",
  LblRequestType: "Typ wniosku",
  LblWegoProcessTime: "Czas procesu Wego",
  LblResult: "Wynik",
  LblWegoResultTime: "Czas wyniku WeGo",
  LblVTSResultTime: "Czas wyniku VTS",
  LblCommandInitiator: "Inicjator polecenia",

  LblTroubleShootVTS: "VTS Troubleshoot",
  LblVtsServiceStatus: "Status usługi VTS",
  LblVtsLicencetag: "Znacznik licencji VTS",
  LblVtsDoorStatus: "Status drzwi",
  LblVtsIssueCommand: "Wydaj Polecenie",
  LblVehicleLocation: "Lokalizacja pojazdu",
  LblEventHistory: "Historia zdarzeń VTS",
  LblView: "Zobacz",
  LblVehicleObuStatus: "Status OBU Pojazdu",
  LblVehicleNotInitialized: "Brak inicjalizacji pojazdu",
  LblLastReceivedTime: "Czas ostatniego otrzymanego komunikatu",

  LblFreePerBookingInterval: "Według przedziału rezerwacji",

  LblSelectFilter: "Wybierz filtr",
  LblAuditEntries: "Kontrola wpisów",
  LblFilter: "Filtr",
  LblCategory: "Kategoria",
  LblEventName: "Nazwa zdarzenia",
  LblEventData: "Dane zdarzenia",
  LblMoment: "Moment",
  LblUser: "Użytkownik",
  LblNoEventDataFound: "Nie znaleziono danych o zdarzeniu",
  LblEventViewer: "Przeglądarka zdarzeń",

  LblSelectObuType: "Wybierz typ urządzenia OBU",

  LblObuType: "Typ OBU",
  LblDeviceId: "Id urządzenia",
  LblClaimCode: "Kod roszczenia",

  LblVtsLocation: "Lokalizacja VTS",
  LblRetriveAddress: "Pobierz adres",
  LblCrearedDate: "Data utworzenia",
  LblCreatedBy: "Utworzony przez",
  LblPerBooking: "Per booking",
  LblOBU: "OBU",
  LblClone: "Sklonuj",
  LblCloneVehicle: "Sklonuj %0",
  LblFualNotRequire: "Paliwo niewymagane",
  LblCleanNotRequire: "Czyszczenie niewymagane",
  LblSubscriptionInfo: "Informacje o subskrypcji",
  LblVehiclDamaged: "Pojazd uszkodzony",
  LblVehicleNotDamaged: "Pojazd nie uszkodzony",
  LblDamage: "Uszkodzony",
  LblFreeBooking: "Dostosuj koszt rezerwacji",
  LblBookingCustomFee: "Niestandardowy koszt rezerwacji",
  LblFreeBookingSuccess: "Koszty rezerwacji zapisane pomyślnie",
  LblEnterLocation: "Wprowadź lokalizację",
  LblHomeLocation: "Lokalizacja domowa",
  LblLocationMode: "Tryb lokalizacji",
  LblMeter: "Metr",
  LblLocation: "Lokalizacja",
  LblPickupLocation: "Lokalizacja odbioru",
  LblLocationUnavailable: "Lokalizacja niedostępna",
  LblAvailabilityCalander: "Kalendarz dostępności",
  LblAvailableOn: "Dostępny na",
  LblGeofenceEnabled: "Geofence włączone",
  LblLocationNotFound: "Nie można ustalić adresu",
  LblAddressNotAvailable: "Nie można ustalić adresu w tej lokalizacji",
  LblReports: "Raporty",
  LblDrivers: "Kierowcy",
  LblTemplates: "Szablony",
  LblVehicleOccupancyReport: "Raport o zajętości pojazdu",
  LblPlaceHolder: "Przykładowy tekst",
  LblSampleTemplate: "Przykładowy szablon",
  LblLatexFileDownloadValidation: "Nieważna zawartość lateksu",
  LblLocationDataExchangeNotAssign:
    "Ten pojazd nie może być zarezerwowany, gdy nie jest do niego przypisany żaden pojazd VTS. Czy chcesz kontynuować?",
  LblReservedTime: "Zarezerwowany czas",
  LblUsageTime: "Czas użytkowania",
  LblUsageTimeAtOffice: "Czas użytkowania w godzinach pracy",
  LblUsageTimeoutOffice: "Czas użytkowania poza godzinami pracy",
  LblRevenue: "Dochód",
  LblRevenuePerVehicleReport: "Raport o przychodach z pojazdu",
  LblSearchRevenuePerVehicle: "Wyszukaj przychód na pojazd",
  LblRevenuePerVehicleList: "Dochód za pojazd Lista",

  //Dashboard
  LblInuse: "W użyciu",
  LblPriority: "Priorytet",
  LblDefaultStatus: "Domyślny status",

  //OdometerLogTrail
  LblOdometerLogTrail: "Ścieżka dziennika licznika kilometrów",
  LblUserProvidedOdometerValueInKmr: "Wartość licznika kilometrów (km)",
  LblDescriptionOfDeviation: "Opis odchylenia",
  LblFromOdometer: "Od licznika",
  LblToOdometer: "Do licznika",
  LblAddDescriptionOfDeviation: "Dodaj opis odchylenia",
  LblDeviation: "Odchylenie (km)",
  LblLastOdometerValue: "Poprzednia wartość licznika kilometrów (km)",
  LblLastOdometerDT: "Data poprzedniego stanu licznika",

  LblOdometerRegistered: "Zarejestrowany licznik kilometrów",
  LblOdometerValue: "Wartość licznika",
  LblMaintenancePlanningList: "Lista planowania konserwacji",
  LblSearchMaintenancePlanningValue: "Wyszukiwanie planów konserwacji",
  LblMaintenancePlanningreport: "Raport z planowania konserwacji",

  LblodometerConfiguration: "Konfiguracja licznika kilometrów",
  LbLOdometerEnabled: "Licznik włączony",
  LblEnableOnApp: "Włącz w aplikacji",
  LblWarningPer: "Ostrzeżenie (%)",
  LblShowDeviation: "Pokaż odchylenie, które wymaga wyjaśnienia",

  LblTitle: "Tytuł",
  LblFooterText: "Tekst stopki",
  LblvalidEmailDomain: "Zezwalaj tylko na adresy e-mail z następującej domeny",
  LblURLSettings: "Ustawienia URL",
  LblSuccessUrl: "Success URL",
  LblEmailSettings: "Ustawienia e-mail",
  LblSendActivationEmail: "Włącz automatyczną aktywację e-maili",
  LblSendConfirmationEmail: "Włącz maile potwierdzające rejestrację",
  LblRequireAdminApprovel: "Wymagaj zatwierdzenia przez administratora nowych zapisów",
  LblDriverInformationToBeInclude:
    "Informacje o kierowcy, które mają być zawarte w formularzu (wszystkie wymagane pola)",
  LblSignUpForm: "Formularz rejestracji",
  LblSignupForms: "Formularze rejestracji",
  LblSignupFormsOverview: "Przegląd formularzy zapisu",
  LblWhoCanApprove: "Kto może zatwierdzać nowe zapisy?",
  LblSignupFormLogo: "Logo formularza zapisu",
  LblChooseSubscription:
    "Wybierz subskrypcję(y) dostępną dla formularza zapisu",
  LblSignupParameter: "Adres URL rejestracji",
  LblSignupParameterText: "Tekst adresu URL rejestracji",
  DomainNameString: "Nazwa domeny oddzielona przecinkami (jak gmail.com, yahoo.com)",
  SignupParameterString: "Tylko litery, cyfry i - są dozwolone",

  LblAvailability: "Dostępność",
  LblSettings: "Ustawienia",
  LblCurrentStatus: "Aktualny status",
  LblFlags: "Flagi",
  LblNA: "NA",

  //Sign up form
  LblConfirmEmail: "Potwierdź e-mail",
  LblSignup: "Zarejestruj się",

  LblSignupsOverView: "Przegląd rejestracji",
  LblSignupApproval: "Zatwierdzenie rejestracji",
  LblAccept: "Zaakceptuj",
  LblSignupFormDescription: "Opis formularza rejestracji",

  LblCurrentOdometerValue: "Aktualna wartość licznika kilometrów",
  LblCurrentOdometerDateTime: "Bieżąca data/godzina licznika kilometrów",

  LblCreateDirectDebitFile: "Tworzenie pliku polecenia zapłaty",
  LblCheckEmptyIbanNumber: "Sprawdź numery IBAN",
  LblCreatedDate: "Data utworzenia",
  LblIncludeInDirectDebit: "Włączenie do pliku polecenia zapłaty",
  LblDirectDebitFileDate: "Data pliku polecenia zapłaty",
  LblDirectDebitConfiguration: "Konfiguracja poleceń zapłaty",
  LbLDirectDebitEnabled: "Włączenie generowania pliku poleceń zapłaty",
  LblDirectDebitEnableper: "Włączenie pliku poleceń zapłaty na",
  LbLCreditorDetails: "Szczegóły wierzyciela",
  LblAddress: "Adres",
  LblIBANNumber: "IBAN",
  LblCountryCode: "Kod kraju",
  LbLBillingInformation: "Informacje o rozliczeniach",
  LblFormat: "Format",
  LblInvoicingDetails: "Szczegóły fakturowania",
  LbLSubjectToDirectDebit: "Czy podlega poleceniu zapłaty?",

  //Person Upload Batch
  LblBatchUploadPersonSetting: "Import wsadowy Ustawienie osoby",
  LblShowBatchUploadInfo: "Zezwól na import wsadowy osoby",
  LblAllowBatchUpload: "Pozwól na import dla",
  LblAllowActivationMail: "Użyj e-maili aktywacyjnych",
  LblGenerateRandomPassword: "System generuje hasła",
  LblUserUploadPassword: "Importuj hasła",
  LblFieldToUploadedOrValidated: "Pola w pliku importowym",
  LblBatchUploadPerson: "Wczytaj osobę",
  LblBatchUpload: "Wysyłaj osoby",
  LblImportDriverRole: "Przypisać automatycznie rolę kierowcy?",
  LblAssignToSVG: "Przypisanie do wspólnej grupy (grup) pojazdów",
  LblSVG: "Grupa wspólnych pojazdów",
  LblDownloadTemplate: "Przykład pliku importowego",
  LblUserAssignSVGMessage: "Użytkownik nie jest jeszcze przypisany do wspólnej grupy pojazdów!",
  LblInvalidRecordReason: "Nieważny rekord(y)",
  LblSelectedSVGs: "Wybrane SVG",

  LblDashboard: "Dashboard",
  LblGroupAdmin: "Administrator grupy",
  LblDashboardConfiguration: "Konfiguracja Dashboardu",
  LblCurrentLocation: "Bieżąca lokalizacja",
  LblEnableCurrentLocation: "Włącz bieżącą lokalizację",
  LblDefaultLocation: "Domyślna lokalizacja",
  LblEnableAutoUpdate: "Włącz automatyczną aktualizację",
  LblPriorityNotificationSetting: "Ustawienia powiadomień o stanie pojazdu",
  LblCollectionDate: "Data odbioru polecenia zapłaty",
  LblBICCode: "Kod BIC",
  LblDirectDebitFile: "Plik polecenia zapłaty",
  LblMissingIBANNumber: "Brakujący numer IBAN",

  LblCurrentDriver: "Aktualny kierowca",
  LblNextDriver: "Następny kierowca",
  LblSecond: "Sekundy",

  LblCleaning: "Czyszczenie",
  LblRefueling: "Tankowanie/ładowanie",
  LblAPKMaintenance: "Konserwacja okresowa",
  LblOutsideGeofence: "Poza geofence",
  LblNotBooked: "Nie zarezerwowany",
  LblNotBookedSince: "Nie zarezerwowane od",
  LblLowBattery: "Niski poziom baterii",
  LblBatteryVolt: "V.",
  LblLowCharge: "Niski poziom naładowania",
  LblChargingPercentage: "%",
  LblOnSamePosition: "Na tej samej pozycji",
  LblLastPosition: "Ostatnia pozycja",
  LblNotReturn: "Nie wraca",
  LblCommunicationProblem: "Problem z komunikacją",
  LblDirectDebitDownloadSuccess: "Plik polecenia zapłaty pobrany",
  LblWarnings: "Ostrzeżenia",
  LblDirectDebitFileId: "Plik polecenia zapłaty Id",
  LblTotalAmount: "Całkowita kwota",
  LblReCreate: "Pobierz ponownie",
  LblPleaseEnterCollectionDate: "Proszę wprowadzić datę pobrania",
  LblOpenViaLowLevel: "Otwarte przez niski poziom",
  LblInstanceNotificationNote1: "Ustawienie działa zgodnie z ustawieniami dla firmy",
  LblNoInvoiceSelected: "Brak wybranych faktur do pliku polecenia zapłaty",
  LblIBANNumberRequired: "Proszę wprowadzić IBAN i BIC",
  LblNoEmptyIBANFound: "Nie znaleziono pustego numeru IBAN",
  LblInvalidTagUsed: "Użyto nieważnego znacznika",
  LblNotInvalidTagUsed: "Nie użyto nieważnego znacznika",

  LblShowVehicleChargeLevel:
    "Pokazać poziom doładowania pojazdu w aplikacji internetowej i mobilnej?",
  LblChargeLevel: "Poziom naładowania",
  LblCharging: "Ładowanie",
  LblNoDataFound: "Brak dostępnych danych",
  LblOfficeStartTime: "Godziny urzędowania Godzina rozpoczęcia (hh:mm)",
  LblOfficeEndTime: "Godzina zakończenia pracy biura (hh:mm)",
  //Reports
  LblTripDataReport: "Raport danych o podróży",
  LblByDriver: "Według kierowcy",
  LblByVehicle: "Według pojazdu",
  LblModuleRights: "Uprawnienia Modułu",
  LblByOrganization: "Według organizacji",
  //Organization
  LblOrganization: "Organizacja",
  LblOrganizationName: "Nazwa organizacji",
  LblExistingDriverAddSuccessMsg:
    "Kierowca został dodany i pomyślnie powiązany z organizacją.",
  LblAddDriverSuccessMsg:
    "Kierowca został dodany, a link aktywacyjny do tego kierowcy został wysłany z powodzeniem.",
  LblOrganizationAddress: "Adres organizacji",
  LblCreateOrganization: "Utwórz organizację",
  LblAddDriverToOrganization: "Dodaj kierowcę do organizacji",
  LblAddDriver: "Dodaj kierowcę",
  LblOrganizationDriversList: "Kierowca organizacji",
  // Branding
  LblBranding: "Branding",
  LblLogo: "Logo",
  LblEmailNotificationInvoiceTemplate: "Powiadomienia e-mail i szablony faktur",
  LblExpandedWebMenu: "Rozwinięte menu aplikacji internetowej",
  LblCollapsedWebMenu: "Zwinięte menu aplikacji internetowej",
  LblMobileApp: "Aplikacja mobilna",
  LblSplashScreen: "Splash screen",
  LblWebApplication: "Aplikacja internetowa",
  LblMobileApplication: "Aplikacja mobilna",
  LblBrandingSavedSuccess: "Branding zapisany pomyślnie",
  LblBrandingTemplateConfiguration: "Konfiguracja marki i szablonu",
  LblAppWebUI: "Aplikacja i Web UI",
  LblNonBookingCommunication: "Komunikacja niezwiązana z rezerwacją",
  LblBookingCommunication: "Komunikacja związana z rezerwacją",
  LblInstanceBranding: "Zawsze używaj marki instancji",
  LblCompanyBranding: "W miarę możliwości używaj brandingu firmy",
  BO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Górny pasek, menu i aktywne elementy",
  BO_TOP_MENU_ACTIVE_ITEM_TEXT: "Tekst menu",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND: "Podświetlony przycisk",
  BO_HIGHLIGHTED_BUTTON_TEXT: "Podświetlony tekst przycisku",
  BO_HIGHLIGHTED_BUTTON_BACKGROUND_HOVER: "Podświetlony przycisk (hover)",
  BO_HIGHLIGHTED_BUTTON_TEXT_HOVER: "Podświetlony tekst przycisku (hover)",
  BO_PRIMARY_BUTTON_BACKGROUND: "Przycisk główny",
  BO_PRIMARY_BUTTON_TEXT: "Tekst przycisku głównego",
  BO_PRIMARY_BUTTON_BACKGROUND_HOVER: "Przycisk główny (hover)",
  BO_PRIMARY_BUTTON_TEXT_HOVER: "Tekst przycisku podstawowego (hover)",
  BO_SECONDARY_BUTTON_BACKGROUND: "Przycisk dodatkowy",
  BO_SECONDARY_BUTTON_TEXT: "Tekst przycisku dodatkowego",
  BO_SECONDARY_BUTTON_BACKGROUND_HOVER: "Przycisk dodatkowy (wysunięcie)",
  BO_SECONDARY_BUTTON_TEXT_HOVER: "Tekst drugiego przycisku (hover)",
  BO_HYPERLINK_TEXT: "Tekst hiperłącza",
  BO_HIGHLIGHT_BACKGROUND: "Kolor podświetlenia",
  BO_HIGHLIGHT_TEXT: "Tekst podświetlenia",
  BO_CALENDAR_EVENT_BACKGROUND: "Wydarzenia z kalendarza",
  BO_CALENDAR_EVENT_TEXT: "Tekst wydarzeń kalendarza",
  MO_TOP_MENU_ACTIVE_ITEM_BACKGROUND: "Górny pasek i menu",
  MO_LOGO_AREA_BACKGROUND: "Tło obszaru logo",
  MO_PAGE_BACKGROUND: "Tło",
  MO_MENU_TEXT: "Tekst menu",
  MO_TITLE_TEXT: "Tekst tytułu",
  MO_HYPERLINK_TEXT: "Tekst hiperłącza",
  MO_ENABLED_BUTTON_BACKGROUND: "Przycisk włączony",
  MO_ENABLED_BUTTON_TEXT: "Tekst przycisku aktywnego",
  MO_ENABLED_BUTTON_BACKGROUND_ACTIVE: "Aktywny przycisk (aktywny)",
  MO_ENABLED_BUTTON_TEXT_ACTIVE: "Tekst aktywnego przycisku (aktywny)",
  MO_DISABLED_BUTTON_BACKGROUND: "Wyłączony przycisk",
  MO_DISABLED_BUTTON_TEXT: "Tekst wyłączonego przycisku",
  MO_DISABLED_BUTTON_BACKGROUND_ACTIVE: "Wyłączony przycisk (aktywny)",
  MO_DISABLED_BUTTON_TEXT_ACTIVE: "Tekst wyłączonego przycisku (aktywny)",
  MO_HIGHLIGHT_BACKGROUND: "Kolor podświetlenia",
  MO_HIGHLIGHT_TEXT: "Tekst podświetlenia",
  MO_CALENDAR_EVENT_BACKGROUND: "Wydarzenia z kalendarza",
  MO_CALENDAR_EVENT_TEXT: "Tekst wydarzeń z kalendarza",
  LblBookingDelayConfig: "Konfiguracja opóźnienia rezerwacji",
  LblBookingDelayConfigEnabled: "Wyślij wiadomość e-mail do administratora",
  LblEnableSnauilTrail: "Włącz wizualizację trasy",
  LblAppSupportTo: "Obsługa aplikacji do",
  LblNotificationInterval: "Częstotliwość powiadomień",
  LblNotifyAfterMinutes: 'Powiadom po X" minutach"',
  LblMinutesAfterBookingEndTime:
    "Ile minut po planowanym czasie zakończenia rezerwacji?",
  LblResendNotoficationEvery: "Wysyłaj ponownie powiadomienie co minutę(y)",
  LblMinutes: "Minuty",
  lblNotificationRecipients: "Odbiorcy powiadomień",
  LbLEnableBookingStillRunning: "Włącz powiadomienie o wciąż trwającej rezerwacji",
  LblBookingrunningNotification:
    "Konfiguracja powiadomienia o wciąż trwającej rezerwacji",
  LblPreferableImageSize: "Preferowany rozmiar obrazu",
  LblWebBrandingExapandImageSize: "1150px X 260px",
  LblMobileBrandingImageSize: "550px X 250px",
  LblWebBrandingCollapseImageSize: "325px X 250px",

  //MobileApp Configuration
  LblMobileAppConfiguration: "Konfiguracja aplikacji mobilnej",
  LblEnableNewBooking: "Włącz nową rezerwację",
  LblEnableBookingCalender: "Włącz kalendarz rezerwacji",
  LblEnableSubscription: "Włącz subskrypcję",
  LblEnableUpdateProfile: "Włącz aktualizację profilu",
  LblEnableNotification: "Włącz powiadomienie",
  LblEnableChangeBooking: "Włącz zmianę rezerwacji",
  LblEnableAddExpenseMenu: "Włącz menu dodawania wydatków",

  //Raise and clear settings for low battery flag
  LblDefaultVehicleSetting: "Domyślne ustawienia pojazdu",
  LblLowBatteryFlagRaised: "Flaga niskiego poziomu naładowania akumulatora jest podniesiona przy (napięcie)",
  LblLowBatteryFlagClear: "Flaga niskiego poziomu naładowania akumulatora jest kasowana przy (napięcie)",
  LblByBooking: "Przez rezerwację",
  LblSnailTrailReport: "Raport z wizualizacją trasy",
  LblKickbackReport: "Raport Kickback",
  LblGroupBy: "Grupa według",
  LblTripDetail: "Szczegóły podróży",
  LblTripNumber: "Nr wycieczki",
  LblStart: "Start",
  LblAverageSpeed: "Średnia prędkość Prędkość",
  LblSegmentDetail: "Szczegółowy segment",
  LblSegmentNumber: "Segment nr",
  LblSpeed: "Prędkość",
  LblOdometer: "Licznik kilometrów",
  LblNext: "Następny",
  LblSegmentDetailNotAvailable: "Szczegóły segmentu niedostępne",
  LblUnitPerKm: "na km.",
  LblUnitPerBooking: "p/bk",

  LblBookingCostSummary: "Podsumowanie kosztów rezerwacji",
  LblTimeCost: "Czas Koszt",
  LblTotalTime: "Czas całkowity",
  LblCostRateUnits: "Koszt (kwota * stawka)",
  LblFreeTime: "Czas wolny",
  LblRate: "Stawka",
  LblExVat: "Wył. VAT",
  LblInclVat: "Wł. VAT",
  LblKmDriven: "Przejechane kilometry",
  LblFreeKms: "Bezpłatne km",
  LblTimePercent: "Czas procent",
  LblTotalExVat: "Razem bez VAT",
  LblTotalVat: "Razem VAT",
  LblTotalInclVat: "Razem z VAT",
  LblKilometerCost: "Koszt kilometra",
  LblFixedCost: "Koszt stały",
  LblTotals: "Razem",
  LblTypeDamage: "Uszkodzenia",
  LblTypeMaintenance: "Należny przegląd okresowy",
  LblTypeOnSamePosition: "Pojazd w tym samym miejscu przez ponad %0 %1",
  LblTypeNotBooked: "Pojazd nie był zarezerwowany przez więcej niż %0 %1",
  LblTypeNotReturn: "Upłynął czas rezerwacji i pojazdu nie ma w miejscu zamieszkania",
  LblBatteryVoltage: "Napięcie akumulatora",

  LblCannotUnsubscribe:
    "Nie można teraz wypisać, ponieważ ten użytkownik ma trwającą rezerwację",
  LblPer: "Za",

  LblDateRegistered: "Data rejestracji",
  LblRegisteredBy: "Zarejestrowany przez",
  LblKMPerHour: "Km/h",
  LblMeters: "Metry",
  LblSubscriptionEndOnBookingEnd:
    "Rezerwacja jest nadal prowadzona dla tego abonamentu. Kierowca zostanie wypisany po zakończeniu rezerwacji.",
  LblMarkedForDeletion: "Oznaczony do usunięcia",
  LblApplyDateFilter: "Data zastosowania",

  LblNoRestriction: "NO_RESTRICTION",
  LblCustomAppTestApp: "CUSTOM_APP_AND_TEST_APP",
  LblCustomAppOnly: "CUSTOM_APP_ONLY",

  //Customer
  LblCustomer: "Klient",
  LblCustomerName: "Nazwa klienta",

  //Role Page
  LblRoleManagement: "Rola",
  LblRoleName: "Nazwa roli",
  LblEntityName: "Nazwa podmiotu",
  LblRoleType: "Typ roli",
  LblRoleAvailability: "Dostępność roli klienta",
  LblInternalRoleName: "Nazwa roli wewnętrznej",
  LblPresentationName: "Nazwa prezentacji",
  LblDefaultRole: "Rola domyślna",
  LblCustomRole: "Rola niestandardowa",
  LblAddRole: "Dodaj rolę",
  LblEntity: "Podmiot",
  LblCopy: "Kopiuj",
  LblAccessibilityMatrix: "Matryca dostępności",
  LblDefaultRoleModifyWarning:
    "Modyfikacja domyślnych uprawnień będzie miała wpływ na wszystkich użytkowników, którzy mają domyślną rolę",
  LblCopyAccessibilityMatrix: "Kopiuj matrycę dostępności",
  LblAccess: "Dostęp",
  LblCustomerAdmin: "Klient Administrator",
  LblAdmin: "Administrator",
  LblDoYouWantToRemove: "Czy chcesz usunąć %0 jako %1?",
  LblDoYouWantToAdd: "Czy chcesz zrobić %0 jako %1?",
  LblRoleAddedSuccess: "%0 dodano do %1 pomyślnie.",
  LblRoleDeletedSuccess: "%0 usunięto z %1 z powodzeniem.",
  LblInstanceAdmin: "Instance Admin",
  LblInvitationMailSuccess:
    "Mail z zaproszeniem został wysłany na podany adres e-mail.",
  LblInvite: "Wyślij zaproszenie",
  LblCreateNew: "Utwórz nową",
  LblCommonErrorMessage:
    "Serwer napotkał błąd podczas przetwarzania żądania. Prosimy o kontakt z administratorem.",
  LblError: "Błąd",
  LblThankYouForAcceptingInvitation: "Dziękujemy za przyjęcie zaproszenia",
  LblPleaseClick: "Proszę kliknąć",
  LblHere: "tutaj",
  LblToLogin: "aby się zalogować",
  LblThankYouForConfirmation: "Dziękujemy za potwierdzenie.",
  LblGoToHome: "przejdź do strony głównej.",
  LblInvitationSuccess: "Zaproszenie Udane",
  LblInvitationReject: "Odrzucenie zaproszenia",

  //
  LblAssignExisting: "Przypisz istniejące",
  LblPersonProfileSuccessMessage: "Twój profil został pomyślnie aktywowany.",
  LblPlease: "Proszę",
  LblLogin: "Zaloguj się",

  //Organization
  LblVatNumber: "Numer VAT",

  //Branding & Template
  LblBrandingandTemplates: "Branding i szablony",
  LblTermsAndCondition: "Zasady i warunki",
  LblTermsAndConditionList: "Lista oświadczeń o ochronie danych osobowych",
  LblName: "Nazwa",
  LblVersion: "Wersja",
  LblAcceptance1: "Przed aktywacją konta",
  LblAcceptanceMoment: "Moment akceptacji",
  LblContents: "Treść",
  LblIsAccept: "Akceptuję",
  LblReadAndAgree: "Przeczytałem i zgadzam się z",
  LblClose: "Zamknij",
  LblTermsConditionPrivacy: "OWU i Oświadczenie o ochronie prywatności",
  LblPrivacyStatements: "Oświadczenie o ochronie prywatności",

  //Pre Post Trip Setting
  LblPrePostTripSetting: "Ustawienia pytań przed i po podróży",
  LblPrePostTripQuestion: "Pytanie przed i po podróży",
  LblPrePostTripQuestionList: "Lista pytań przed i po podróży",
  LblPreTripQuestion: "Pytania przed podróżą",
  LblCustom: "Własna strona",
  LblPostTripQuestion: "Pytania po podróży",
  LblRequired: "Wymagane",
  LblBeforeOpeningTheVehicle: "Przed otwarciem pojazdu",
  LblAfterOpeningTheVehicle: "Po otwarciu pojazdu",
  LblOrder: "Zamówienie",
  LblQuestion: "Pytanie",
  LblOn: "Na stronie",
  LblOptional: "Opcjonalnie",
  LblOff: "Wyłączone",
  LblAnswerType: "Typ odpowiedzi",
  LblText: "Tekst",
  LblYesNo: "Tak/Nie",
  LblAnswer: "Odpowiedź",
  LblTimeStamp: "Znacznik czasu",
  LblFazTripQuestion: "Pytania FaZ",
  LblFazTripQuestionAfterClosingTheVehicle: "Pytania FaZ po zamknięciu pojazdu",

  //Accessibility Matrix
  LG_WEB_DASHBOARD: "Pulpit nawigacyjny",
  PR_BOOKING_REQUEST: "Wniosek o rezerwację",
  LblApproveBookingRequest: "Zatwierdź",
  LblRejectBookingRequest: "Odrzuć",
  PR_DASHBOARD: "Deska rozdzielcza",
  PR_REMOVE_DRIVER_LICENSE: "Usuń prawo jazdy",
  PR_VEHICLE_FUTURE_BOOKINGS: "Przyszłe rezerwacje pojazdu",
  PR_INSTANCE: "Instancja",
  PR_BRANDING: "Branding",
  PR_PERSON_OVERVIEW: "Przegląd osób",
  PR_WEGO_ADMINS: "Wego Admins",
  PR_COMPANY_OVERVIEW: "Przegląd firmy",
  PR_CONTACT_PERSON: "Osoba kontaktowa",
  PR_COMPANY_ADMIN: "Administrator firmy",
  PR_COMPANY_VEHICLE_OVERVIEW: "Przegląd pojazdów",
  PR_COMPANY_SVG_OVERVIEW: "Przegląd SVG firmy",
  PR_ORGANIZATION_OVERVIEW: "Przegląd organizacji",
  PR_ORGANIZATION_CONTACT_PERSON: "Osoba Kontaktowa Organizacji",
  PR_ORGANIZATION_ADMIN_OVERVIEW: "Przegląd Administratorów Organizacji",
  PR_ORGANIZATION_DRIVER_OVERVIEW: "Przegląd Kierowców Organizacji",
  PR_SHARED_VEHICLE_GROUP_OVERVIEW: "Przegląd grupy współdzielonych pojazdów",
  PR_SHARED_VEHICLE_GROUP_ADMIN_OVERVIEW: "Przegląd administratora grupy współdzielonych pojazdów",
  PR_SHARED_VEHICLE_GROUP_VEHICLE_OVERVIEW:
    "Grupa współdzielonych pojazdów Przegląd pojazdów",
  PR_SHARED_VEHICLE_GROUP_DRIVER_OVERVIEW:
    "Przegląd kierowców grupy współdzielonych pojazdów",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_GROUP_OVERVIEW:
    "Przegląd grupy pojazdów Grupa typu umowy",
  PR_SHARED_VEHICLE_GROUP_CONTRACT_TYPE_OVERVIEW:
    "Przegląd Grupy Pojazdów Typ Umowy",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Przegląd grupy pojazdów - abonament",
  PR_SHARED_VEHICLE_GROUP_SUBSCRIPTION_AVAILIBILTY_RESTRICTION_OVERVIEW:
    "Przegląd ograniczeń dostępności abonamentu dla grupy współdzielonych pojazdów",
  PR_SPECIAL_PERIODS: "Okresy specjalne",
  PR_VEHICLES_OVERVIEW: "Przegląd pojazdów",
  PR_VEHICLE_SVG_OVERVIEW: "Przegląd pojazdów SVG",
  PR_VTS_VEHICLE_LIST: "Lista pojazdów VTS",
  PR_VTS_TROUBLESHOOT: "Rozwiązywanie problemów VTS",
  PR_VEHICLE_ATTRIBUTE_CATEGORIES: "Kategorie atrybutów pojazdu",
  PR_VEHICLE_ATTRIBUTE: "Atrybut pojazdu",
  PR_ODOMETER_LOG_TRAIL: "Ścieżka dziennika pomiaru",
  PR_ODOMETER_LOG_TRAIL_REGISTERED_BY: "Ślad licznika kilometrów zarejestrowany przez",
  PR_DRIVER_OVERVIEW: "Kierowca Przegląd",
  PR_DRIVER_SHARED_VEHICLE_GROUP_OVERVIEW:
    "Przegląd grupy pojazdów współdzielonych przez kierowcę",
  PR_DRIVER_SHARED_VEHICLE_GROUP_SUBSCRIPTION_OVERVIEW:
    "Przegląd abonamentów Grupy Pojazdów Współdzielonych przez Kierowcę",
  PR_BOOKINGS_OVERVIEW: "Przegląd rezerwacji",
  PR_PRE_POST_TRIP_QUESTIONS: "Przegląd pytań przed podróżą",
  PR_NORMAL_BOOKING: "Nowa rezerwacja",
  PR_SPECIAL_BOOKING: "Rezerwacja specjalna",
  PR_TRIP_SIMULATOR: "Symulator podróży",
  PR_INVOICE: "Faktura",
  PR_DIRECT_DEBIT_FILE: "Plik polecenia zapłaty",
  PR_ADDITIONAL_FREE_ITEMS: "Dodatkowe darmowe pozycje",
  PR_TEST_INVOICE_GENERATOR: "Generator faktur testowych",
  PR_VEHICLE_OCCUPANCY_REPORT: "Raport o zajętości pojazdu",
  PR_REVENUE_PER_VEHICLE_REPORT: "Raport o przychodach na pojazd",
  PR_TRIP_DATA_REPORT: "Raport danych o podróży",
  PR_MAINTENANCE_PLANNING_REPORT: "Raport o planowaniu obsługi technicznej",
  PR_SANIL_TRAIL_REPORT: "Raport z wizualizacją trasy",
  PR_KICKBACK_REPORT: "Raport zwrotów akcji",
  PR_INVOICE_PAYMENT_HISTORY: "Historia płatności faktur",
  PR_TEMPLATES: "Szablony",
  PR_SIGNUP_FORMS_OVERVIEW: "Przegląd formularzy rejestracji",
  PR_SIGNUPS_OVERVIEW: "Przegląd formularzy zapisu",
  PR_SIGNUP_OVERVIEW_TO_SIGNUP_FORM: "Przegląd rejestracji do formularza rejestracji",
  PR_SIGNUP_OVERVIEW_TO_SHARED_VEHICLE_GROUP:
    "Przegląd rejestracji do grupy pojazdów współdzielonych",
  PR_TERMS_AND_CONDITION: "Warunki i zasady",
  PR_EVENT_VIEWER: "Przeglądarka zdarzeń",
  PR_PRE_POST_TRIP_SETTING: "Ustawienia pytań przed podróżą",
  PR_PREPOST_TRIP_QUESTIONS_UPDATE: "Pytania przed podróżą",
  PR_USER_PROFILE: "Profil użytkownika",
  LG_CUSTOMER: "Klient",
  LG_INSTANCE: "Instancja",
  LG_BRANDING: "Branding",
  LG_PERSON: "Osoba",
  LG_COMPANY: "Firma",
  LG_ORGANIZATION: "Organizacja",
  LG_SHARED_VEHICLE_GROUP: "Grupa pojazdów współdzielonych",
  LG_VEHICLE: "Pojazd",
  LG_DRIVER: "Kierowca",
  LG_BOOKING: "Rezerwacja",
  LG_INVOICE: "Faktura",
  LG_REPORT: "Raport",
  LG_TEMPLATE: "Szablon",
  LG_SIGNUP_FORM: "Formularz zgłoszeniowy",
  LG_EVENT_VIEWER: "Przeglądarka wydarzeń",
  LG_PRE_POST_TRIP_SETTING: "Ustawienia pytań przed i po podróży",
  LG_USER: "Użytkownik",
  LG_BRANDING_AND_TEMPLATE: "Branding i szablony",
  LG_ROLE: "Rola",
  LG_PREPOSTTRIPQUESTION: "Pytania przed podróżą",
  PR_CUSTOMER_ADMIN_OVERVIEW: "Przegląd funkcji Customer Admin",
  PR_INSTANCE_ADMIN_OVERVIEW: "Przegląd administratorów instancji",
  PR_ROLE_OVERVIEW: "Rola",
  PR_ROLE_ASSIGN: "Przypisanie roli",
  PR_SHARED_VEHICLE_GROUP_ACTIVE_INACTIVE:
    "Wspólna grupa pojazdów aktywna lub nieaktywna",
  PR_CUSTOMER_OVERVIEW: "Klient",
  PR_ORGANIZATION_SUBSCRIPTION_OVERVIEW: "Organizacja Przegląd subskrypcji",
  PR_VTS_VEHICLE_EVENT_HISTORY: "Historia zdarzeń pojazdu VTS",
  PR_BATCH_UPLOAD_PERSON: "Przesyłanie partii osób",
  PR_IMPORT_PERSON: "Importuj osobę",
  PR_PRE_POST_TRIP_QUESTION_UPDATE: "Pytania dotyczące podróży przed i po",

  LG_REPORTINGTOOL: "Narzędzie do raportowania",
  PR_BOOKING_OVERVIEW: "Przegląd rezerwacji",
  PR_ROB_NOTIFICATIONS: "Przegląd ROB",
  PR_MILEAGE_OVERVIEW: "Przegląd przebiegu",
  PR_USAGE_OVERVIEW: "Liczba dni niewykorzystanych",
  PR_POSITION_ON_MAP: "Pozycja na mapie",
  PR_VEHICLE_ON_LOCATION_MAP: "Pojazd na miejscu",
  PR_TRIP_OVERVIEW: "Rejestracja wycieczki",
  PR_ALTERNATE_TRANSPORTATION: "Pojazdy zastępcze",
  PR_AVERAGE_OVERVIEW: "Przegląd średnichi",
  PR_PRE_POST_BOOKING_OVERVIEW: "Pytania przed/post na przegląd rezerwacji",
  PR_HOME_LOCATIONS_OVERVIEW: "Przegląd lokalizacji pojazdów i domów SVG",

  LblPrivacyErrorMessage: "Nie masz uprawnień do oglądania tej strony",
  LblPrivacyNavigate: "Proszę przejść do",
  LblPrivacyError: "Błąd prywatności",
  LblLinkExpired: "Link wygasł",
  LblLinkExpiredMessage:
    "Link stracił ważność i nie może być już używany. Proszę spróbować ponownie.",
  LblBearer: "Bearer",
  LblWhoBenifitFreeItem: "Kto korzysta z kredytów subskrypcyjnych?",
  LblNoDistinction: "Domyślnie (bez rozróżnienia)",
  LblSendInvoiceToOrganization: "Wyślij fakturę do organizacji",

  //Vat Setting
  LblVatSettings: "Ustawienia VAT",
  LblVatPercentages: "Stawki VAT",
  LblDefaultCost: "Domyślnie, pokaż i edytuj koszty",
  LblExcludingVat: "Z wyłączeniem podatku VAT",
  LblIncludingVat: "Z VAT",
  LblVatEnterDescription: "Wprowadź opis",
  LblEnterVatPercentage: "Wprowadź % VAT",
  LblVatPercentageError: "Wprowadź prawidłową wartość procentową",
  LblVatDescriptionError: "Proszę wpisać prawidłowy opis",
  LblVatStartDate: "Data rozpoczęcia",
  LblVatStartDateError: "Proszę wybrać datę rozpoczęcia",
  LblStartDate: "Data rozpoczęcia",
  LblVatEndDate: "Data końcowa",
  LblVatDeleteConfirmation: "Czy na pewno chcesz ustawić datę końcową VAT?",
  LblVatEndDateError: "Proszę wprowadzić datę końcową VAT",
  LblVatEndDateNote: "Uwaga: Dane zostaną wyłączone od wybranej daty",
  LblDefaultVatContractTypeGroupCost: "VAT % dla Grupy Rodzaju Umowy Koszty",
  LblDefaultVatContractTypeCost: "VAT % dla kosztów typu umowy",
  LblDefaultVatSubscriptionCost: "VAT % dla kosztów abonamentu",
  LblPenaltyCost: "Koszty karne",
  LblTimeRates: "Stawki za czas",
  LblDistanceRates: "Stawki za odległość",
  LblFixedRates: "Stałe stawki",
  LblSubscriptionCost: "Koszty abonamentu",

  LblPenaltyVat: "Opłata karna VAT",
  LblTimeRateVat: "Stawka czasowa VAT",
  LblMileageRateVat: "Stawka milowa VAT",
  LblFixedFeeVat: "Stała opłata VAT",
  LblExpenseAmountVat: "Kwota wydatków VAT",
  // template
  LblEmailTemplate: "Szablon e-mail",
  LblWebTemplate: "Szablon internetowy",
  LblEmailAddressesEntryPattern:
    "Adresy e-mail oddzielone przecinkami (np. ex1@ex.com, ex2@ex.com)",
  LblNoRecipientWarning:
    "Brak odbiorców. Domyślnymi odbiorcami będą odbiorcy tego szablonu.",
  LblCostAndExpenses: "Koszty i wydatki",
  LblSender: "Nadawca",
  LblAddressee: "Adresat",
  LblAddLine: "Dodaj linię",
  LblSaveInvoice: "Zapisz fakturę",
  LblVatAmount: "Kwota VAT",
  LblBookingId: "Id rezerwacji",
  LblReceiptOrSuppor: "Potwierdzenie lub wsparcie",
  LblVATPercentage: "VAT(%)",
  LblChargeTo: "Obciążenie do",
  LblReimburseTo: "Zwrot kosztów do",
  LblReportedBy: "Zgłoszony przez",
  LblReportedAmount: "Kwota zgłoszona",
  LblApprovedAmount: "Zatwierdzona kwota",
  LblCostType: "Rodzaj kosztów",
  LblRecipient: "Odbiorca",
  LblCostDetail: "Szczegóły dotyczące kosztów",
  LblCostCenterReport: "Raport Centrum Kosztów",
  LblShowTotalOnly: "Pokaż tylko sumę",
  LblChamberOfCommerce: "Izba Handlowa",
  LblInvoicingSettings: "Ustawienia fakturowania",
  LblInvoiceSender: "Nadawca faktury",

  LblAddExisting: "Dodaj istniejące",
  LblReceiptOrSupport: "Pokwitowanie lub wsparcie",
  LblManualInvoiceLine: "Ręczna linia faktury",
  LblInvoiceLine: "Linia faktury",
  LblInvoice: "Faktura",
  LblInvoiceLines: "Linie faktury",
  LblSendInvoice: "Wyślij fakturę",
  LblInvoiceSent: "Wysłana faktura",
  LblAddNewInvoiceLine: "Dodaj nową linię faktury",
  LblSelectUnprocessedExpenses: "Wybierz nieprzetworzony wydatek",
  LblSelectAtLeastOneExpense: "Proszę wybrać co najmniej jeden wydatek",
  PR_COST_EXPENSES: "Koszty i wydatki",
  PR_COST_CENTER_REPORT: "Raport Centrum Kosztów",

  LblInactiveAfterDays: "Nieaktywny po (dniach)",
  LblMarkDeleteAfterDays: "Zaznacz Usuń po (dni)",
  LblNotifyAdminBeforeDays: "Powiadom administratora przed (dni)",
  LblGdprSettings: "Ustawienia GDPR",
  LblRemovalDate: "Data usunięcia",
  LblRemovePersonOn: "Usuń osobę na",
  LblInvoicePaymentHistory: "Historia płatności faktury",
  LblPaymentMode: "Tryb płatności",
  LblLogTime: "Czas logowania",
  LblWhenOpeningAppAndRepeat:
    "Przy pierwszym otwarciu aplikacji i powtarzać za każdym razem",
  LblEveryTimeOpenApp: "Przy każdym otwarciu aplikacji",
  LblWhenMakeBooking: "Przy dokonywaniu rezerwacji",
  LblWhenStartBooking: "Przy rozpoczynaniu rezerwacji",
  LblWhenOpenBooking: "Przy otwieraniu pojazdu",
  LblSelectContractTypeGroup: "Przy wyborze konkretnego typu umowy Grupa(y)",
  LblDays: "Dni",
  LblNewVersion: "Nowa wersja",
  LblAction: "Działanie",
  LblTAndCName: "Nazwa T&C",
  LblOldVersion: "Stara wersja",
  LblSureToRevoke: "Czy jesteś pewien, że chcesz odwołać T&C?",
  LblNoPaymentLinkGenerated: "Nie wygenerowano linku do płatności",

  //Payment Module
  LblPaymentConfig: "Konfiguracja płatności",
  LblPaymentConfigButton: "Konfiguracja płatności",
  LblPaymentProvider: "Dostawca płatności",
  LblCountry: "Kraj",
  LblEmailAddress: "Adres e-mail",
  LblAllowPaymentConfiguration: "Zezwól na konfigurację płatności",
  LblAllowPayment: "Zezwolenie na płatność",
  LblPaymentSetting: "Ustawienia dostawcy płatności",
  LblEnvironment: "Środowisko",
  LblInvoicePaymentTermDays: "Warunki płatności faktury dni",
  LblLinkValidityDays: "Dni ważności linku",
  LblPaymentMethods: "Metody płatności",
  LblPaymentProviderSecretKey: "Tajny klucz PSP",
  LblPaymentProviderUsername: "Nazwa użytkownika PSP (klucz)",
  LblCreditCardPayment: "Płatność kartą kredytową",
  LblInitialPayment: "Płatność początkowa",
  LblCreateBookingPayment: "Utwórz rezerwację Płatność",
  LblStartBookingPayment: "Rozpoczęcie Rezerwacji Płatności",
  LblPaymentLink: "Link do płatności",
  LblPaymentHistory: "Historia płatności",
  LblReasonOrganization: "Powód zablokowania organizacji",
  LblDueDateUpdateSuccess: "Termin płatności Zaktualizowano pomyślnie",
  LblDueDateRequiredError: "Proszę wybrać termin płatności.",
  LblDueDate: "Data płatności",
  LblConfirmDuedatechange: "Czy na pewno chcesz zaktualizować termin płatności?",
  LblConfirmCloseInvoice: "Czy na pewno chcesz zamknąć fakturę?",
  LblConfirmReOpenInvoice: "Czy na pewno chcesz ponownie otworzyć fakturę?",
  LblInvoiceOpenCloseSuccess: "Faktura %0 pomyślnie",
  LblReOpen: "Otwórz ponownie",
  LblClosed: "Zamknięto",
  LblReOpenClose: "Otwórz ponownie / Zamknij",
  PR_PAYMENT_HISTORY_LIST: "Historia płatności",
  LblUserBlockMessage: "Blokada użytkownika Wiadomość",
  PR_BLOCK_UNBLOCK_ORGANIZATION: "Zablokuj / Odblokuj Organizację",
  LblReportedOn: "Zgłoszony",
  LblCurrencyConfiguration: "Konfiguracja waluty",
  LblNameSingular: "Nazwa pojedyncza",
  LblNamePlural: "Nazwa Liczba mnoga",

  //Special Period
  LblRegularBooking: "Rezerwacja regularna",
  LblSpecialRate: "Cena specjalna",
  LblFirstDay: "Pierwszy dzień",
  LblLastDay: "Ostatni dzień",
  LblWeekEndContaining: "Weekend Zawierający",
  LblSignBeforeAmount: "Symbol waluty przed kwotą",

  //Credit card payment
  LblCrediCardPayment: "Płatność kartą kredytową",
  LblFirstBooking: "Pierwsza rezerwacja",
  LblAllowRecurringPayment: "Autoryzacja karty kredytowej",
  LblProceed: "Kontynuuj",
  LblCheckAllowPayment: "Proszę zaznaczyć, aby umożliwić powtarzające się płatności.",

  LblPaymentFailed: "Autoryzuj kartę kredytową",
  LblPaymentSuccess: "Sukces autoryzacji",
  LblPaymentFailure: "Niepowodzenie autoryzacji",
  LblCompletedSuccess: "Twoja autoryzacja została przeprowadzona pomyślnie.",

  LblCompletedFailure:
    "Twoja autoryzacja nie powiodła się. Proszę wrócić i spróbować ponownie.",
  LblCreditCardNumber: "Numer karty kredytowej",
  LblCreditCardExpirationDate: "Data ważności karty kredytowej",
  LblCreditCardDetails: "Szczegóły karty kredytowej",
  LblMakePayment: "Autoryzacja karty kredytowej",
  LblAdminPaymentConfirmation:
    "Nie ma aktywnej autoryzacji lub potrącenie z karty nie powiodło się. Czy chcesz kontynuować?",
  LblPaymentDescription:
    "Aby zarezerwować pojazd, wymagana jest płatność weryfikacyjna w wysokości %0. Dodatkowo wymagana jest zgoda na potrącanie przyszłych płatności z Twojej karty kredytowej. Płatności są przetwarzane przez naszego dostawcę płatności Buckaroo. Zostaniesz przekierowany na stronę Buckaroo, aby dokonać faktycznej płatności.",
  LblPay: "Zapłać",
  LblOutOf: "Z",
  // NIF Number
  LblEnableNIFNumber: "Włącz numer identyfikacji podatkowej",
  LblNIFNumber: "Numer identyfikacji podatkowej",
  LblWeGoDefault: "WeGo Default",
  LblPersonActiveSuccess: "Osoba pomyślnie aktywowana",
  LblActivate: 'Aktywuj',
  LblInActiveReason: "InActive Reason",
  LblDefaultLanguage: 'Domyślny język',
  LblRestoreInheritConfirmation: "Bieżące ustawienia zostaną zastąpione przez ustawienia dziedziczone. Czy jesteś pewien?",
  LblQestionTextRequired: "Wymagany tekst pytania",
  LblManualSecretKey: "Tajny klucz",

  // Two Factor Authentication
  LblTwoFaConfig: "Uwierzytelnianie dwuskładnikowe",
  LblEnableTwoFa: "Włącz uwierzytelnianie dwuskładnikowe",
  LblExpirationDays: "Dni wygaśnięcia",
  LblTextBoxExpirationDays: "Dni wygaśnięcia",
  Lbl2FactorAuthenticateExpDays: "Okres ważności 2FA (w dniach):",
  LblResetCookiesWegoAdmin: "Zresetuj pliki cookie dla wszystkich administratorów WeGo",
  LblReset2FactorAuthWegoAdmin: "Resetuj wszystkie 2FA dla wszystkich administratorów WeGo",
  LblAuthentication: "Uwierzytelnianie",
  LblResetCookiesForAllAdmin: "Resetuj pliki cookie dla wszystkich administratorów",
  LblReset2FaForAllAdmin: "Zresetuj 2FA dla wszystkich administratorów",

  LblEnterTotp: "Proszę wprowadzić kod",
  LblEnterOtp: "Proszę wprowadzić kod",
  LblSubmit: "Prześlij",
  LblKeyResetSuccess: "Klucz 2FA został zresetowany",
  LblKeyResetFailed: "Reset klucza 2FA nie powiódł się",
  LblCookieResetSuccess: "Ciasteczka 2FA zostały zresetowane",
  LblCookieResetFailed: "Nie udało się zresetować plików cookie 2FA",
  LblGoogleAuthenticator: "Aplikacja Google Authenticator",
  LblEmailOtpSent: "Kod został wysłany na Twój zarejestrowany adres e-mail.",
  LblContinue: "Kontynuuj",
  LblInvalidTOTP: "Nieważny kod",
  LblResetCookie: "Zresetuj ciasteczka",
  LblResetTwoFA: "Wyzeruj 2FA",
  LblDisableTwoFA: "Wyłącz 2FA",
  LblTwoFaMethod: "Metoda 2FA",
  LblEmailAuthentication: "Uwierzytelnianie przez e-mail",
  LblTwoFaMethodSelect:"Będziesz musiał zweryfikować swoją tożsamość jeszcze raz. Proszę wybrać metodę 2FA",
  LblInvoicePreFix: "Prefiks numeru faktury",
  LblEngineStillRunning:'Polecenie blokady wysłane podczas pracy silnika',
  LblMobileAppLink: "Link do aplikacji mobilnej",

  // License Check Configuration
  LblLicenseCheckConfiguration: "Licencja Sprawdź Konfigurację",
  LblValidateLicenseCheckForBooking: "Sprawdzenie rezerwacji",

  // Access Cards Enabled SVG
  LblAccessCardsEnabled: "Użycie karty dostępu",

  // Payment Methods
  LblIdeal: "Ideal",
  LblBCMC: "BCMC",
  LblSepa: "Sepa",
  LblPaypal: "Paypal",
  LblCreditCard: "Karta kredytowa",
  LblSofort: "Sofort",
  LblMyBank: "MyBank",
  LblGiroPay: "GiroPay",

  // Track & Trace
  LblTrackAndTrace: "Track & Trace",
  LblRfidTagId: "Identyfikator znacznika RFID",
  LblEmployeeNumber: "Numer pracownika",
  BtnAddVehicleInfo: "Pokaż VTS Log",

  // Access Card
  LblAccessCardId: "Identyfikator karty dostępu",

  LblDriversLicenseAndCertificates: "Prawo jazdy i certyfikaty",
  LblLicense: "Prawo jazdy",
  LblCertificates: "Świadectwa",

  LblTrips: "Wycieczki",
  LblCostsSummary: "Podsumowanie kosztów",
  LblStartBooking: "Rozpocznij rezerwację",
  LblStopBooking: "Zatrzymaj rezerwację",

  LblTripHistory: "Historia podróży",
  LblTripStartDateTime : "Od",
  LblTripEndDateTime: "Do",
  LblFaZTripQuestions: "Pytania FaZ",
  LblNoQuestionsFound: "Nie znaleziono pytań FaZ.",
  LblNoTripsFound: "Nie znaleziono podróży.",
  LblTripDetails: "Szczegóły podróży",
  LblUnansweredQuestions: "Pytania bez odpowiedzi",
  LblNoUnansweredQuestions: "Brak pytań bez odpowiedzi",
  LblAnswerSaved: "Odpowiedź została pomyślnie zapisana",
  LblAnswerSavedError: "Nie udało się zapisać odpowiedzi. Prosimy o kontakt z Administratorem",
  LblAnswerEmptyError: "Proszę podać poprawną odpowiedź",

  LblLoginError: "Podczas logowania wystąpił nieznany błąd",
  LblLoginCredentialsError: "Ta nazwa użytkownika lub hasło są nieprawidłowe, proszę sprawdzić i spróbować ponownie.",
  LblBookingStarted: "Rezerwacja została rozpoczęta",
  LblCouldnotStartBooking: "Rezerwacja nie może zostać rozpoczęta",
  LblBookingStopped: "Rezerwacja została zatrzymana",
  LblCouldnotStopBooking: "Nie można zatrzymać rezerwacji",
  ValidatePhoneNumberVts: "Proszę wpisać prawidłowy numer telefonu (np. +31623456789)",
  LblInfo: "Info"
}



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./src/app/shared/translate/lang-pl.ts